// 订单管理
<template>
    <div class="main">
        <el-row :gutter="10" class="mar_tb">
            <el-col :span="24">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <i class="icon iconfont icon-danju-xiugai-tianchong" style="margin-right:2px;"></i>
                        <span style="font-size:13px;">订单信息</span>
                    </div>
                    <div class="search-content mar_b" style="margin-top:-15px;margin-bottom:-15px;">
                        <el-form :inline="true" label-width="180px" size="mini" 
                            :model="query" class="demo-form-inline" ref="query">
                        <el-col :span="12">
                            <el-form-item prop="status" label="订单状态：" label-width="90px">
                                <el-select v-model="statusOptions" placeholder="请选择" @change="getStatusOptions" clearable multiple>
                                    <el-option v-for="item in order_typeList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item prop="suppliers" label="供应商：" label-width="90px">
                                <el-input v-model="query.suppliers" placeholder="请输入"></el-input>
                            </el-form-item><br>
                            <el-form-item prop="danhao" label="" label-width="90px" style="margin-top:-15px">
                                <el-select v-model="query.danhao" placeholder="请选择" style="width:90px">
                                    <el-option label="证书号" value="1"></el-option>
                                    <el-option label="订单号" value="2"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item prop="goods_no" label="" label-width="90px" style="margin-top:-15px">
                                <el-input v-model="query.goods_no" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item prop="create_user" label="业务员：" label-width="90px" style="margin-top:-15px">
                                <el-input v-model="query.create_user" placeholder="请输入"></el-input>
                            </el-form-item><br>
                            <!--
                            <el-form-item prop="huiyuan" label="" label-width="90px" style="margin-top:-15px">
                                <el-select v-model="query.huiyuan" placeholder="请选择" style="width:90px">
                                    <el-option label="会员账号" value="1"></el-option>
                                    <el-option label="公司简称" value="2"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item prop="name" label="" label-width="90px" style="margin-top:-15px">
                                <el-input v-model="query.name" placeholder="请输入"></el-input>
                            </el-form-item><br>
                            -->
                            <el-form-item prop="place" label="地点：" label-width="90px" style="margin-top:-15px">
                                <el-select v-model="query.place" placeholder="请选择" clearable>
                                    <el-option v-for="item in placeList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                            <!--
                            <el-form-item prop="received_type" label="款项：" label-width="90px" style="margin-top:-15px">
                                <el-select v-model="query.received_type" placeholder="请选择" clearable>
                                    <el-option v-for="item in received_typeList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                            -->
                            <el-form-item prop="clients" label="客户姓名：" label-width="90px" style="margin-top:-15px">
                                <el-input v-model="query.clients" placeholder="请输入"></el-input>
                            </el-form-item>
                            <br>
                            <el-form-item prop="shape" label="形状：" label-width="90px" style="margin-top:-15px">
                                <el-select v-model="query.shape" placeholder="请选择" clearable>
                                    <el-option v-for="item in shapeList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item prop="remark" label="备注：" label-width="90px" style="margin-top:-15px">
                                <el-input v-model="query.remark" placeholder="请输入"></el-input>
                            </el-form-item><br>
                            <el-form-item prop="ct" label="重量：" label-width="90px" style="margin-top:-15px">
                                <el-select v-model="query.ct" placeholder="请选择" clearable style="width:120px"
                                        @blur="ctSelect" @change="ctChange" filterable allow-create>
                                        <el-option label="0.30-0.39" value="3"></el-option>
                                        <el-option label="0.40-0.49" value="4"></el-option>
                                        <el-option label="0.50-0.59" value="5"></el-option>
                                        <el-option label="0.60-0.69" value="6"></el-option>
                                        <el-option label="0.70-0.79" value="7"></el-option>
                                        <el-option label="0.80-0.89" value="8"></el-option>
                                        <el-option label="0.90-0.99" value="9"></el-option>
                                        <el-option label="1.00-1.09" value="10"></el-option>
                                        <el-option label="1.10-1.49" value="11"></el-option>
                                        <el-option label="1.50-1.99" value="12"></el-option>
                                        <el-option label="2.00-2.99" value="13"></el-option>
                                        <el-option label="3.00-3.99" value="14"></el-option>
                                        <el-option label="4.00-4.99" value="15"></el-option>
                                        <el-option label="5.00-10.00" value="16"></el-option>
                                </el-select>
                                <el-input v-model="query.ct3" placeholder="请输入" style="width:80px" @change="ctChange3"></el-input>
                                -<el-input v-model="query.ct4" placeholder="请输入" style="width:80px" @change="ctChange4"></el-input>
                            </el-form-item><br>
                            <el-form-item prop="order_date" label="下单日期：" label-width="90px" style="margin-top:-15px">
                                <el-date-picker v-model="query.order_date" type="datetimerange" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                                </el-date-picker>
                            </el-form-item><br>
                            <!--
                            <el-form-item prop="pick_date" label="取货日期：" label-width="90px" style="margin-top:-15px">
                                <el-date-picker v-model="query.pick_date" type="datetimerange" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                                </el-date-picker>
                            </el-form-item><br>
                            -->
                            <el-form-item prop="pay_date" label="付款日期：" label-width="90px" style="margin-top:-15px">
                                <el-date-picker v-model="query.pay_date" type="datetimerange" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                                </el-date-picker>
                            </el-form-item><br>
                            <el-form-item class="search-but" style="margin-top:-15px;float:right">
                                <el-button type="primary" @click="selectList">查询</el-button>
                                <el-button @click="resetForm('query')">重置</el-button>
                            </el-form-item><br>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item prop="col" label="颜色：" label-width="60px">
                                <el-checkbox-group v-model="checkboxGroup2" size="small" @change="checkboxChange2">
                                    <el-checkbox-button v-for="color in colorlist" :label="color" :key="color">{{color}}</el-checkbox-button>
                                </el-checkbox-group>
                            </el-form-item><br>
                            <el-form-item prop="cla" label="净度：" label-width="60px" style="margin-top:-15px">
                                <el-checkbox-group v-model="checkboxGroup3" size="small" @change="checkboxChange3">
                                    <el-checkbox-button v-for="cla in clalist" :label="cla" :key="cla">{{cla}}</el-checkbox-button>
                                </el-checkbox-group>
                            </el-form-item><br>
                            <el-form-item prop="cut" label="切工：" label-width="60px" style="margin-top:-15px">
                                <el-checkbox-group v-model="checkboxGroup4" size="small" @change="checkboxChange4">
                                    <el-checkbox-button v-for="cut in cutlist" :label="cut" :key="cut">{{cut}}</el-checkbox-button>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item prop="3EX" label="" label-width="60px" style="margin-top:-15px;float:right;margin-right:150px">
                                <el-button type="primary" @click="select3exn" size="small">3EX-N</el-button>
                            </el-form-item>
                            <br>
                            <el-form-item prop="pol" label="抛光：" label-width="60px" style="margin-top:-15px">
                                <el-checkbox-group v-model="checkboxGroup5" size="small" @change="checkboxChange5">
                                    <el-checkbox-button v-for="pol in pollist" :label="pol" :key="pol">{{pol}}</el-checkbox-button>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item prop="EX" label="" label-width="60px" style="margin-top:-15px;float:right;margin-right:150px">
                                <el-button type="primary" @click="selectexn" size="small">EX-N</el-button>
                            </el-form-item>
                            <br>
                            <el-form-item prop="sym" label="对称：" label-width="60px" style="margin-top:-15px">
                                <el-checkbox-group v-model="checkboxGroup6" size="small" @change="checkboxChange6">
                                    <el-checkbox-button v-for="sym in pollist" :label="sym" :key="sym">{{sym}}</el-checkbox-button>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item prop="VG" label="" label-width="60px" style="margin-top:-15px;float:right;margin-right:150px">
                                <el-button type="primary" @click="selectvgn" size="small">VG-N</el-button>
                            </el-form-item>
                            <br>
                            <el-form-item prop="fl" label="荧光：" label-width="60px" style="margin-top:-15px">
                                <el-checkbox-group v-model="checkboxGroup7" size="small" @change="checkboxChange7">
                                    <el-checkbox-button v-for="fl in fllist" :label="fl" :key="fl">{{fl}}</el-checkbox-button>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item prop="mine" label="" label-width="60px" style="margin-top:-15px;float:right;margin-right:150px">
                                <el-checkbox v-model="checked">我的订单</el-checkbox>
                            </el-form-item><br>
                        </el-col>
                        </el-form>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <el-row :gutter="10" class="mar_tb" sytle="height:30px">
            <el-col :span="24">
                <el-card class="box-card">
                    <div class="text e-info auto-table">
                        <el-button type="primary" @click="selectCertno" :disabled="isAble" size="small">获取证书号</el-button>
                        <el-button type="primary" @click="exportSelect" :disabled="isAble" size="small">导出选中</el-button>
                        <el-button type="primary" @click="selectAllOrderList" size="small">导出全部</el-button>
                        <el-button type="success" @click="printOrders" :disabled="isAble" size="small">打印订单</el-button>
                        <!--<el-button type="primary" @click="dialogTableVisible1 = true" size="small" :disabled="isAble">取货</el-button>-->
                        <el-button type="primary" @click="dialogTableVisible4 = true" size="small" :disabled="isAble">借货</el-button>
                        <el-button type="primary" @click="dialogTableVisible9 = true" size="small" :disabled="isAble">全款借货</el-button>
                        <el-button type="warning" @click="dialogTableVisible2 = true" size="small" :disabled="isAble">作废</el-button>
                        <el-button type="primary" @click="dialogTableVisible3 = true" size="small" :disabled="isAble">收款</el-button>
                        <el-button type="primary" @click="dialogTableVisible7 = true" size="small" :disabled="isAble">钻石报价</el-button>
                        <!--
                        <el-button type="primary" @click="dialogTableVisible6 = true" size="small" :disabled="isAble">调整折扣</el-button>
                        <el-button type="primary" @click="dialogTableVisible5 = true" size="small" :disabled="isAble">调整汇率</el-button>
                        -->
                        <!--<el-button type="primary" @click="dialogTableVisible8 = true" size="small" :disabled="isAble">删除选中</el-button>-->
                        <el-button type="success" @click="printOrdersInvoice" :disabled="isAble" size="small">打印Invoice</el-button>
                        <el-button type="primary" @click="printOrdersCashMemo" :disabled="isAble" size="small">打印Memo</el-button>
                        <el-button type="primary" @click="closeOutAllOrders" size="small" :disabled="isAble">批量结清</el-button>
                        <!--
                        <el-button type="warning" @click="dialogTableVisible11 = true" size="small" :disabled="isAble">退货</el-button>
                        -->
                        <!--
                        <el-button type="primary" @click="printOrdersInvoiceBR" :disabled="isAble" size="small">打印invoice-有BR</el-button>
                        -->
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <el-row :gutter="10" class="mar_tb" sytle="height:30px">
            <el-col :span="24">
                <el-card class="box-card">
                    <!--分页-->
                    <div class="block tar mar_t">
                        <div class="text e-info auto-table">
                            <span style='float:left;font-size:18px'> 已选：{{data_len}}； 总克重：{{ ct_total }}； 总售价￥{{ sale_price_total }}； 总实收￥{{ received_total }}；总实收${{ received_usd_total }}</span>
                        </div>
                        <el-pagination @size-change="sizeChange" @current-change="pageChange" :current-page="pager.page"
                                       :page-sizes="[20, 50, 100, 200, 500, 1000]" :page-size="pager.rows"
                                       layout="total,sizes, prev, pager, next, jumper"
                                       :total="pager.total"></el-pagination>
                    </div>
                    <div class="text e-info auto-table">
                        <el-table :data="orderInfoList" stripe size="mini" height='600px'
                            @selection-change="selectionLineChangeHandle"
                            ref="refTable" @expand-change="expandChange"
                            :header-cell-style="{background:'#eef1f6',color:'black',fontSize:'10px',padding:'0 0',margin:'0 0'}" 
                            :row-style="{height:'10px',color:'black',fontSize:'11px',padding:'0 0',margin:'0 0'}">
                            <el-table-column type="selection" align="center" width="45"></el-table-column>
                            <el-table-column align="center" min-width="13%" prop="orders_no" label="订单号"></el-table-column>
                            <el-table-column align="center" min-width="12%" prop="status" label="订单状态"></el-table-column>
                            <el-table-column align="center" min-width="10%" prop="remark" label="备注"></el-table-column>
                            <el-table-column align="center" min-width="8%" prop="place" label="地点"></el-table-column>
                            <el-table-column align="center" min-width="22%" prop="canshu" label="参数">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.ct }}ct</span>
                                    <span>{{ scope.row.shape }}</span>
                                    <span>{{ scope.row.col }}</span>
                                    <span>{{ scope.row.cla }}</span>
                                    <br>
                                    <span>{{ scope.row.cut }}</span>
                                    <span>{{ scope.row.pol }}</span>
                                    <span>{{ scope.row.sym }}</span>
                                    <span>{{ scope.row.fl }}</span>
                                </template>
                            </el-table-column>
                            <!--
                            <el-table-column align="center" min-width="8%" prop="shape" label="形状"></el-table-column>
                            <el-table-column align="center" min-width="8%" prop="ct" label="重量" sortable></el-table-column>
                            <el-table-column align="center" min-width="6%" prop="col" label="颜色"></el-table-column>
                            <el-table-column align="center" min-width="8%" prop="cla" label="净度"></el-table-column>
                            <el-table-column align="center" min-width="6%" prop="cut" label="切工"></el-table-column>
                            <el-table-column align="center" min-width="6%" prop="pol" label="抛光"></el-table-column>
                            <el-table-column align="center" min-width="6%" prop="sym" label="对称"></el-table-column>
                            <el-table-column align="center" min-width="6%" prop="fl" label="荧光"></el-table-column>
                            -->
                            <el-table-column align="center" min-width="7%" prop="cert" label="证书"></el-table-column>
                            <el-table-column align="center" min-width="13%" prop="cert_no" label="证书号">
                                <!--<template slot-scope="scope">
                                    <el-popover trigger="click" placement="top">
                                    <p>证书号: {{ scope.row.cert_no }}</p>
                                    <p>形状: {{ scope.row.shape }}</p>
                                    <p>重量: {{ scope.row.ct }}</p>
                                    <p>颜色: {{ scope.row.col }}</p>
                                    <p>净度: {{ scope.row.cla }}</p>
                                    <p>切工: {{ scope.row.cut }}</p>
                                    <p>抛光: {{ scope.row.pol }}</p>
                                    <p>对称: {{ scope.row.sym }}</p>
                                    <p>荧光: {{ scope.row.fl }}</p>
                                        <div slot="reference" class="name-wrapper">
                                            <el-tag size="medium">{{ scope.row.cert_no }}</el-tag>
                                        </div>
                                    </el-popover>
                                </template>-->
                            </el-table-column>
                            <el-table-column align="center" min-width="8%" prop="sale_rap" label="Rap"></el-table-column>
                            <el-table-column align="center" min-width="12%" prop="orders_usd" label="USD"></el-table-column>
                            <el-table-column align="center" min-width="12%" prop="price" label="RMB" sortable></el-table-column>
                            <el-table-column align="center" min-width="10%" prop="back" label="退点" sortable></el-table-column>
                            <el-table-column align="center" min-width="9%" prop="rate" label="汇率"></el-table-column>
                            <el-table-column align="center" min-width="12%" prop="clients" label="客户姓名"></el-table-column>
                            <el-table-column align="center" min-width="12%" prop="received" label="实收"></el-table-column>
                            <el-table-column align="center" min-width="12%" prop="received_usd" label="实收USD"></el-table-column>
                            <el-table-column align="center" min-width="12%" prop="create_user" label="业务员"></el-table-column>
                            <el-table-column align="center" min-width="12%" prop="order_date" label="下单日期"></el-table-column>
                            <!--<el-table-column align="center" min-width="11%" prop="pick_date" label="取货日期"></el-table-column>-->
                            <el-table-column align="center" min-width="12%" prop="pay_date" label="付款日期"></el-table-column>
                            <!--<el-table-column align="center" min-width="100" prop="data_date" label="数据日期"></el-table-column>-->
                            <el-table-column align="center" min-width="20" prop="caozuo" label="操作">
                                <template slot-scope="scope">
                                    <el-button type="primary" size="mini" 
                                        @click="selectOrderList(scope.row)" >修改</el-button>
                                    <el-button type="primary" size="mini" 
                                        v-if="scope.row.status=='确认销售'"
                                        @click="closeOutOrders(scope.row)">已完成</el-button>
                                    <el-button type="primary" size="mini" 
                                        v-if="scope.row.status=='借货-待退货'|scope.row.status=='全款借货-待退货'"
                                        @click="rebackOrders(scope.row)">确认退货</el-button>
                                    <el-button type="primary" size="mini" style="display:none"
                                        @click="toggleExpand(scope.row)">查看详情</el-button>
                                </template>
                            </el-table-column>
                            <!--
                            <el-table-column type="expand">
                                <template slot-scope="props">
                                    <el-table :data="props.row.ruleItemData"
                                         border style="width: 50%;">
                                         <el-table-column align="center" width="100" prop="project" label="原退点" show-overflow-tooltip></el-table-column>
                                         <el-table-column align="center" width="100" prop="project" label="进货价" show-overflow-tooltip></el-table-column>  
                                    </el-table>
                                </template>
                            </el-table-column>
                            -->
                        </el-table>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <!--操作按钮部分dialog-->
        <div class="text e-info auto-table">
            <el-dialog title="证书号" :visible.sync = "dialogTableVisible" @close="closeSava" 
                width="600px" center :close-on-click-modal="false">
                <el-form :inline="true" label-width="150px" size="mini" 
                    :model="addDataForm2" class="demo-form-inline" ref="addDataForm2" :rules="rules">
                    <el-form-item prop="remark">
                        <el-input type="textarea" :autosize="{minRows:5, maxRows:10}" style="width:550px;"
                            placeholder="请输入内容" v-model="certnoStr">
                        </el-input>
                    </el-form-item>
                </el-form>
            </el-dialog>
        </div>
        <template>
        <div id="printJS-form" style="display: none;">
            <span style="float:left;font-size:20px;">客户: {{ clients_val }}</span>
            <span style="float:left;margin-left:300px;font-size:20px;">业务:</span>
            <span style="float:right;margin-right:200px;font-size:20px;">出货日期:{{ queryDate }}</span><br><br>
            <span style="float:left;font-size:20px;">出货单号:{{ orders_val }}</span><br><br>
            <el-table ref="table"
                :data="printOrdersInfoList" 
                show-summary
                :summary-method ="getSummaries"
                style="width: 100%">
                <el-table-column width="50" type="index" label="序号"></el-table-column>
                <el-table-column width="120" prop="orders_no" label="订单号" fixed></el-table-column>
                <el-table-column width="50" prop="shape" label="形状"></el-table-column>
                <el-table-column width="50" prop="ct" label="重量"></el-table-column>
                <el-table-column width="50" prop="col" label="颜色"></el-table-column>
                <el-table-column width="50" prop="cla" label="净度"></el-table-column>
                <el-table-column width="50" prop="cut" label="切工"></el-table-column>
                <el-table-column width="50" prop="pol" label="抛光"></el-table-column>
                <el-table-column width="50" prop="sym" label="对称"></el-table-column>
                <el-table-column width="50" prop="fl" label="荧光"></el-table-column>
                <el-table-column width="50" prop="cert" label="证书"></el-table-column>
                <el-table-column width="110" prop="cert_no" label="证书号"></el-table-column>
                <el-table-column width="90" prop="back" label="退点"></el-table-column>
                <el-table-column width="50" prop="rate" label="汇率"></el-table-column>
                <el-table-column width="120" prop="price_r" label="金额(元)"></el-table-column>
                <el-table-column width="120" prop="order_date" label="下单日期" :formatter="formatterDate"></el-table-column>
            </el-table><br><br>
            <span style="float:left;font-size:20px;">制单:</span>
            <span style="float:left;margin-left:380px;font-size:20px;">复核:</span>
            <span style="float:right;margin-right:300px;font-size:20px;">客户签收:</span><br>
            <br><br>
            <span style="float:left;font-size:20px;">1、收货方签收货品后需要认真检验钻石底尖是否破损 、有无奶咖绿、证书是否有污损 、钻石腰码是否和证书一致，如货品有问题请在当场告知我司，如已离场未及时告知，送货方则默认收货方已经验收并确认货品完好无误。货品一经出售恕不退还。</span>
            <span style="float:left;font-size:20px;">2、属于全款借货情况的，收货方退还货品后，我公司会在收到货品当场验收货品，如货品有问题则会与收货方沟通并协商解决，如未及时回复，则默认本公司已经验收并确认货品完好无误。</span>
        </div>
        <!--
        <div id="printJS-form" style="display: none;text-align:center">
            <span style="font-size:20px;text-align:center">GIA钻石销售清单</span><br>
            <span style="float:left;font-size:20px;">购货方: {{ clients_val }}</span>
            <br><br>
            <el-table ref="table"
                :data="printOrdersInfoList" 
                show-summary
                :summary-method ="getSummaries"
                style="width: 100%">
                <el-table-column width="50" type="index" label="序号"></el-table-column>
                <el-table-column width="50" prop="cert" label="证书"></el-table-column>
                <el-table-column width="110" prop="cert_no" label="证书号"></el-table-column>
                <el-table-column width="50" prop="shape" label="形状"></el-table-column>
                <el-table-column width="50" prop="ct" label="重量ct"></el-table-column>
                <el-table-column width="50" prop="col" label="颜色"></el-table-column>
                <el-table-column width="50" prop="cla" label="净度"></el-table-column>
                <el-table-column width="50" prop="cut" label="切工"></el-table-column>
                <el-table-column width="50" prop="pol" label="抛光"></el-table-column>
                <el-table-column width="50" prop="sym" label="对称"></el-table-column>
                <el-table-column width="50" prop="fl" label="荧光"></el-table-column>
                <el-table-column width="50" prop="sale_rap" label="Rap"></el-table-column>
                <el-table-column width="90" prop="back" label="优惠折扣"></el-table-column>
                <el-table-column width="120" prop="sale_usd" label="金额(USD)"></el-table-column>
                <el-table-column width="120" prop="price" label="优惠价"></el-table-column>
                <el-table-column width="120" prop="order_date" label="下单时间"></el-table-column>
            </el-table><br><br>
            <span style="float:left;font-size:20px;text-align:left">
                1、收货方签收货品后需要认真检验钻石底尖是否破损、证书是否有污损、
                钻石腰码是否和证书一致，如货品有问题请在收货后24小时内告知我公司，
                如未及时告知，送货方则默认收货方已经验收并确认货品完好无误。
            </span><br>
            <span style="float:left;font-size:20px;text-align:left">
                2、收货方退还货品后，我公司会在收到货品后24小时内验收货品，
                如货品有问题则会与收货方沟通并协商解决，
                如未及时回复，则默认本公司已经验收并确认货品完好无误。
            </span><br>
            <div class="search-content mar_b">
                <el-form :inline="true" label-width="180px" size="mini" 
                    :model="query1" class="demo-form-inline" ref="query1">
                    <el-form-item prop="xs" style="float:left;font-size:20px;">
                        <span style="font-size:20px;">销售方：深圳乐蒂斯珠宝有限公司</span>
                    </el-form-item>
                    <el-form-item prop="sh" style="float:right;margin-right:400px;font-size:20px;">
                        <span style="font-size:20px;">收货方：{{ clients_val }}</span>
                    </el-form-item><br>
                    <el-form-item prop="sh1">
                        <span>&nbsp;</span>
                    </el-form-item><br>
                    <el-form-item prop="xsdb" style="float:left;font-size:20px;">
                        <span style="font-size:20px;">销售方代表确认：</span>
                    </el-form-item>
                    <el-form-item prop="shdb" style="float:right;margin-right:400px;font-size:20px;">
                        <span style="font-size:20px;">收货方代表确认：</span>
                    </el-form-item><br>
                    <el-form-item prop="sh2">
                        <span>&nbsp;</span>
                    </el-form-item><br>
                    <el-form-item prop="shrq" style="float:left;font-size:20px;">
                        <span style="font-size:20px;">送货日期：</span>
                    </el-form-item>
                    <el-form-item prop="sh2rq" style="float:right;margin-right:400px;font-size:20px;">
                        <span style="font-size:20px;">收货日期：</span>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        -->
        </template>

        <template>
        <div id="printJS-form2" style="display: none;">
            <div>
                <table style="text-align:left;width:100%;line-height: 20px;" frame="void" id='table_t1'>
                    <thead>
                        <tr>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <br>
                    <tbody style="line-height:20px">
                        <tr>
                            <td align="left" style="font-size:25px;width:60%; border-top-style:none;border-bottom-style:none;border-right-style:none;padding-bottom: 15px;">TO: {{ clients_val }}</td>
                            <td align="left" style="font-size:25px;border-top-style:none;border-bottom-style:none;border-left-style:none;padding-bottom: 15px;">INVOICE NO.: {{ other_val }}</td>
                        </tr>
                        <tr>
                            <td style="font-size:25px;width:60%; border-top-style:none;border-bottom-style:none;border-right-style:none;"></td>
                            <td style="font-size:25px;width:60%; border-top-style:none;border-bottom-style:none;border-right-style:none;"></td>
                        </tr>
                        <tr>
                            <td align="left" style="font-size:25px;width:60%; border-top-style:none;border-bottom-style:none;border-right-style:none;padding-bottom: 15px;">Tel: </td>
                            <td align="left" style="font-size:25px;border-top-style:none;border-bottom-style:none;border-left-style:none;padding-bottom: 15px;">INVOICE DATE: {{ queryDate }}</td>
                        </tr>
                        <tr>
                            <td style="font-size:25px;width:60%; border-top-style:none;border-bottom-style:none;border-right-style:none;"></td>
                            <td style="font-size:25px;width:60%; border-top-style:none;border-bottom-style:none;border-right-style:none;"></td>
                        </tr>
                        <tr>
                            <td align="left" style="font-size:25px;width:60%; border-top-style:none;border-bottom-style:none;border-right-style:none;padding-bottom: 15px;"></td>
                            <td align="left" style="font-size:25px;border-top-style:none;border-bottom-style:none;border-left-style:none;padding-bottom: 15px;">TERMS：COD</td>
                        </tr>
                    </tbody>
                </table>
                <table style="text-align:left;width:100%;line-height: 20px;" frame="void" id='table_t2'>
                    <thead>
                        <tr>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <br>
                    <tbody style="line-height:20px">
                        <tr>
                            <td align="left" style="font-size:25px;width:60%; border-top-style:none;border-bottom-style:none;border-right-style:none;padding-bottom: 15px;">TO: {{ clients_val }}</td>
                            <td align="left" style="font-size:25px;border-top-style:none;border-bottom-style:none;border-left-style:none;padding-bottom: 15px;">MEMO NO.: {{ orders_val }}</td>
                        </tr>
                        <tr>
                            <td style="font-size:25px;width:60%; border-top-style:none;border-bottom-style:none;border-right-style:none;"></td>
                            <td style="font-size:25px;width:60%; border-top-style:none;border-bottom-style:none;border-right-style:none;"></td>
                        </tr>
                        <tr>
                            <td align="left" style="font-size:25px;width:60%; border-top-style:none;border-bottom-style:none;border-right-style:none;padding-bottom: 15px;">Tel: </td>
                            <td align="left" style="font-size:25px;border-top-style:none;border-bottom-style:none;border-left-style:none;padding-bottom: 15px;">MEMO DATE: {{ queryDate }}</td>
                        </tr>
                        <tr>
                            <td style="font-size:25px;width:60%; border-top-style:none;border-bottom-style:none;border-right-style:none;"></td>
                            <td style="font-size:25px;width:60%; border-top-style:none;border-bottom-style:none;border-right-style:none;"></td>
                        </tr>
                        <tr>
                            <td align="left" style="font-size:25px;width:60%; border-top-style:none;border-bottom-style:none;border-right-style:none;padding-bottom: 15px;"></td>
                            <td align="left" style="font-size:25px;border-top-style:none;border-bottom-style:none;border-left-style:none;padding-bottom: 15px;"> </td>
                        </tr>
                    </tbody>
                </table>
                <br>
                <!--
                <span style="float:left;font-size:25px;">M/S: {{ clients_val }}</span>
                <span style="float:right;margin-right:100px;font-size:25px;">INV Date:{{ queryDate }}</span><br><br>
                <span style="float:right;margin-right:100px;font-size:25px;">INV NO.:{{ orders_val }}</span><br><br>
                -->
                <span id='span_t1' style="float:left;font-size:25px;margin-left: 45%;">INVOICE</span><br>
                <span id='span_t2' style="float:left;font-size:25px;margin-left: 45%;">MEMO</span><br>
                
                <table style="width:100%;">
                    <thead>
                        <tr style="height:30px">
                            <th align="center" style="width:10%; border-right-style:none;">ITEM NO</th>
                            <th align="center" style="width:30%; border-right-style:none;">GOODS DESCRIPTION</th>
                            <th align="center" style="width:10%; border-right-style:none;">PCS</th>
                            <th align="center" style="width:10%; border-right-style:none;">CARATS</th>
                            <th align="center" style="width:20%; border-right-style:none;">UNIT PRCE USD</th>
                            <th align="center" style="width:19%;">AMOUNT USD</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr style="height:30px">
                            <td align="center" style="padding-bottom: 10px;">1</td>
                            <td align="center" style="padding-bottom: 10px;">Cut & Polished Diamond</td>
                            <td align="center" style="padding-bottom: 10px;">{{ data_len }}</td>
                            <td align="center" style="padding-bottom: 10px;">{{ od_ct }}</td>
                            <td align="center" style="padding-bottom: 10px;"> </td>
                            <td align="center" style="padding-bottom: 10px;">{{ od_usd }}</td>
                        </tr>
                        <tr style="height:30px">
                            <td align="center" style="padding-bottom: 10px;"> </td>
                            <td align="center" style="padding-bottom: 10px;"> </td>
                            <td align="center" style="padding-bottom: 10px;"> </td>
                            <td align="center" style="padding-bottom: 10px;"> </td>
                            <td align="center" style="padding-bottom: 10px;"> </td>
                            <td align="center" style="padding-bottom: 10px;"> </td>
                        </tr>
                        <tr style="height:30px">
                            <td align="center" style="padding-bottom: 10px;"> </td>
                            <td align="center" style="padding-bottom: 10px;"> </td>
                            <td align="center" style="padding-bottom: 10px;"> </td>
                            <td align="center" style="padding-bottom: 10px;"> </td>
                            <td align="center" style="padding-bottom: 10px;"> </td>
                            <td align="center" style="padding-bottom: 10px;"> </td>
                        </tr>
                        <tr style="height:30px">
                            <td align="center" style="padding-bottom: 10px;"> </td>
                            <td align="center" style="padding-bottom: 10px;">TOTAL</td>
                            <td align="center" style="padding-bottom: 10px;">{{ data_len }}</td>
                            <td align="center" style="padding-bottom: 10px;">{{ od_ct }}</td>
                            <td align="center" style="padding-bottom: 10px;">USD</td>
                            <td align="center" style="padding-bottom: 10px;">{{ od_usd }}</td>
                        </tr>
                    </tbody>
                </table><br><br>

                <!--
                <el-table ref="table"
                    :data="printOrdersInfoList" 
                    show-summary
                    :summary-method ="getSummaries2"
                    style="width: 1000px">
                    <el-table-column>
                        <el-table-column width="150" type="index" label="ITEM NO"></el-table-column>
                        <el-table-column width="250" prop="gd" label="GOODS DESCRIPTION "></el-table-column>
                        <el-table-column width="150" prop="pcs" label="PCS"></el-table-column>
                        <el-table-column width="150" prop="ct" label="CARATS"></el-table-column>
                        <el-table-column width="150" prop="upu" label="UNIT PRCE USD"></el-table-column>
                        <el-table-column width="200" prop="orders_usd_r" label="AMOUNT USD"></el-table-column>
                    </el-table-column>
                    
                    <el-table-column label="Parameters">
                        <el-table-column width="130" prop="orders_no" label="CertificateNo" fixed></el-table-column>
                        <el-table-column width="60" prop="shape" label="Shape"></el-table-column>
                        <el-table-column width="70" prop="ct" label="Carat"></el-table-column>
                        <el-table-column width="60" prop="col" label="Color"></el-table-column>
                        <el-table-column width="60" prop="cla" label="Clarity"></el-table-column>
                    </el-table-column>
                    <el-table-column width="50" prop="cut" label="切工"></el-table-column>
                    <el-table-column width="50" prop="pol" label="抛光"></el-table-column>
                    <el-table-column width="50" prop="sym" label="对称"></el-table-column>
                    <el-table-column width="50" prop="fl" label="荧光"></el-table-column>
                    <el-table-column width="50" prop="cert" label="证书"></el-table-column>
                    <el-table-column width="110" prop="cert_no" label="证书号"></el-table-column>
                    <el-table-column width="120" prop="order_date" label="下单日期" :formatter="formatterDate"></el-table-column>
                    <el-table-column label="Amount">
                        <el-table-column width="80" prop="sale_rap" label="Raplist"></el-table-column>
                        <el-table-column width="80" prop="back" label="Disc(%)"></el-table-column>
                        <el-table-column width="80" prop="orders_usd_r" label="US$"></el-table-column>
                    </el-table-column>
                    
                </el-table><br><br>
                -->
                <br></br>
                <table style="width:100%;">
                    <thead>
                        <tr>
                            <th align="left" style="width:25%; border-right-style:none;">Beneficiary Name : </th>
                            <th colspan="2">KABO UNIVERSAL LIMITED</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td align="left" style="padding-bottom: 10px;">Bank Details：</td>
                            <td align="left" style="padding-bottom: 10px;">HSBC</td>
                            <td align="left" style="padding-bottom: 10px;">China Construction Bank (Asia) Corporation Ltd</td>
                        </tr>
                        <tr>
                            <td align="left" style="border-top-style:none;padding-bottom: 10px;">Beneficiary Account No. :</td>
                            <td align="left" style="border-top-style:none;padding-bottom: 10px;">004-149-108482-838(USD)</td>
                            <td align="left" style="border-top-style:none;padding-bottom: 10px;">846210422565</td>
                        </tr>
                        <tr>
                            <td align="left" style="border-top-style:none;padding-bottom: 10px;">Beneficiary Bank Name : </td>
                            <td align="left" style="border-top-style:none;padding-bottom: 10px;">The Hong Kong and Shanghai Banking Corporation Ltd</td>
                            <td align="left" style="border-top-style:none;padding-bottom: 10px;">China Construction Bank (Asia) Corporation Limited</td>
                        </tr>
                        <tr>
                            <td align="left" style="border-top-style:none;padding-bottom: 10px;">Beneficiary Bank Address :</td>
                            <td align="left" style="border-top-style:none;padding-bottom: 10px;">1 Queen’s Road Central</td>
                            <td align="left" style="border-top-style:none;padding-bottom: 10px;">28/F CCB Tower, 3 Connaught Road Central, Central, Hong Kong</td>
                        </tr>
                        <tr>
                            <td align="left" style="border-top-style:none;padding-bottom: 10px;">Bank Swift Code:</td>
                            <td align="left" style="border-top-style:none;padding-bottom: 10px;">HSBCHKHHHKH</td>
                            <td align="left" style="border-top-style:none;padding-bottom: 10px;">CCBQHKAX</td>
                        </tr>
                        <!--
                        <tr>
                            <td align="left" style="border-top-style:none;border-bottom-style:none;">USD A/C</td>
                            <td style="border-top-style:none;border-bottom-style:none;"></td>
                        </tr>
                        <tr>
                            <td align="left" style="border-top-style:none">SWIFT Code</td>
                            <td style="border-top-style:none"></td>
                        </tr>
                        -->
                    </tbody>
                </table>
                <br><br><br>

                <table style="text-align:left;width:100%;" frame="below" id='table_t11'>
                    <thead>
                        <tr>
                            <th style="border-bottom-style:none;">Notice:</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td align="left" style="border-top-style:none;border-bottom-style:none;">1. The ownership of the goods will not pass to the purchaser and will remain with the company untill payment in full of the purchase price of the purchase price of the goods owing to the company by the purchaser.</td>
                        </tr>
                        <tr>
                            <td align="left" style="border-top-style:none;border-bottom-style:none;">2. All goods are sold & delivered in HK.</td>
                        </tr>
                        <tr>
                            <td align="left" style="border-top-style:none;border-bottom-style:none;">3. Goods once sold are not returnable!</td>
                        </tr>
                        <tr>
                            <td align="left" style="border-top-style:none;border-bottom-style:none;">4. 2% interest per month on the total invoice amount will be charged for the payment made after due date.</td>
                        </tr>
                        <tr>
                            <td align="left" style="border-top-style:none;border-bottom-style:none;">5. The diamonds herein invoiced have been purchased from legitimate source not involved in funding conflict and in compliance with United Nations resolution.</td>
                        </tr>
                        <tr>
                            <td align="left" style="border-top-style:none;">6. The contract is governed by the laws of HKSAR.</td>
                        </tr>
                    </tbody>
                </table>
                <table style="text-align:left;width:100%;" frame="below" id='table_t22'>
                    <thead>
                        <tr>
                            <th style="border-bottom-style:none;">Notice:</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td align="left" style="border-top-style:none;border-bottom-style:none;">1. Memo Date cannot over <span style="font-weight: bold;font-size: 25px;">3 days</span> and onwer have a right to ask for return.</td>
                        </tr>
                        <tr>
                            <td align="left" style="border-top-style:none;border-bottom-style:none;">2. The goods ONLY keep for inspection and MUST returned to the onwer at a good condition.</td>
                        </tr>
                        <tr>
                            <td align="left" style="border-top-style:none;border-bottom-style:none;"></td>
                        </tr>
                        <tr>
                            <td align="left" style="border-top-style:none;border-bottom-style:none;"></td>
                        </tr>
                        <tr>
                            <td align="left" style="border-top-style:none;border-bottom-style:none;"></td>
                        </tr>
                        <tr>
                            <td align="left" style="border-top-style:none;border-bottom-style:none;"></td>
                        </tr>
                    </tbody>
                    <br><br><br></br>
                </table>
                <br><br><br><br>
                <table style="text-align:left;width:100%;" frame="void">
                    <thead>
                        <tr>
                            <th align="left" style="width:55%;"></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td align="left" style="border-top-style:none;border-bottom-style:none;border-right-style:none;font-size: 20px;">For and on behalf of,</td>
                            <td align="left" style="border-top-style:none;border-bottom-style:none;border-left-style:none;font-size: 20px">Received and above goods &</td>
                        </tr>
                        <tr>
                            <td align="left" style="border-top-style:none;border-bottom-style:none;border-right-style:none;font-size: 20px">KABO UNIVERSAL LIMITED</td>
                            <td align="left" style="border-top-style:none;border-bottom-style:none;border-left-style:none;font-size: 20px">Agreed to pay</td>
                        </tr>
                    </tbody>
                </table><br><br><br><br>
                <table style="width:100%;" frame="void">
                    <thead>
                        <tr>
                            <th align="center" style="border-bottom-style:none;border-right-style:none;font-size:25px;"></th>
                        </tr>
                    </thead>
                </table>
                <table style="width:45%;float:left">
                    <thead>
                        <tr>
                            <th align="left" border="1" style="border-style:dashed;border-bottom-style:none;border-right-style:none;border-left-style:none;font-size:14px;">Authorized Signature</th>
                        </tr>
                    </thead>
                </table>
                <table style="width:45%;float:right">
                    <thead>
                        <tr>
                            <th align="left" border="1" style="border-style:dashed;border-bottom-style:none;border-right-style:none;border-left-style:none;font-size:14px;">Company Chop and Signature</th>
                        </tr>
                    </thead>
                </table>
            </div>
            <br></br><br>
            <div style="text-align:center">
                <span style="font-size:25px;text-align:center">Packing List</span>
                <br><br>
                <el-table ref="table"
                    :data="printOrdersInfoList" 
                    show-summary
                    :summary-method ="getSummaries5"
                    style="width: 1070px">
                    <el-table-column width="110" prop="cert_no" label="CertNo"></el-table-column>
                    <el-table-column width="100" prop="shape" label="Shape">
                        <template slot-scope="scope">
                            <span v-if="scope.row.shape === '圆形'">Round</span>
                            <span v-else-if="scope.row.shape === '公主方'">Princess</span>
                            <span v-else-if="scope.row.shape === '雷迪恩'">Radiant</span>
                            <span v-else-if="scope.row.shape === '阿斯切'">Asscher</span>
                            <span v-else-if="scope.row.shape === '马眼' || scope.row.shape === '马眼形'">Marquise</span>
                            <span v-else-if="scope.row.shape === '椭圆' || scope.row.shape === '椭圆形'">Oval</span>
                            <span v-else-if="scope.row.shape === '祖母绿'">Emerald</span>
                            <span v-else-if="scope.row.shape === '梨形'">Pear</span>
                            <span v-else-if="scope.row.shape === '心形'">Heart</span>
                            <span v-else-if="scope.row.shape === '垫形'">Cushion</span>
                            <span v-else-if="scope.row.shape === '其他'">Others</span>
                            <span v-else-if="scope.row.shape === '三角形'">Triangle</span>
                            <span v-else>{{ scope.row.shape }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column width="100" prop="ct" label="Weight"></el-table-column>
                    <el-table-column width="60" prop="col" label="Color"></el-table-column>
                    <el-table-column width="60" prop="cla" label="Clarity"></el-table-column>
                    <el-table-column width="60" prop="cut" label="Cut"></el-table-column>
                    <el-table-column width="60" prop="pol" label="Polish"></el-table-column>
                    <el-table-column width="80" prop="sym" label="Symmetry"></el-table-column>
                    <el-table-column width="50" prop="fl" label="Flu"></el-table-column>
                    <el-table-column width="100" prop="cert" label="Certificate"></el-table-column>
                    <el-table-column width="70" prop="sale_rap" label="Rap"></el-table-column>
                    <el-table-column width="100" prop="back" label="Discount"></el-table-column>
                    <el-table-column width="100" prop="received_usd" label="SaleUSD"></el-table-column>
                </el-table>
            </div>
            <!--
            <table style="width:100%;" frame="void">
                <thead>
                    <tr>
                        <th align="center" style="border-bottom-style:none;border-right-style:none;font-size:25px;">E. & O. E.</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td align="left" border="1" style="border-style:dashed;border-bottom-style:none;border-right-style:none;">Athorized Signature:</td>
                        <td align="left" style="border-style:dashed;border-bottom-style:none;border-left-style:none;border-right-style:none;float:left;margin-left:100px">Chop & Signature:</td>
                    </tr>
                </tbody>
            </table>-->
            <!--
            <br><br><br><br>
            <table style="text-align:center;width:100%;" frame="void">
                <thead>
                    <tr>
                        <th style="border-top-style:none;border-bottom-style:none;font-size:16px;">尖沙咀寶勒巷3-7A號萬事昌廣場1806室 電話: (852) 5667 0493</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td style="border-top-style:none;border-bottom-style:none;font-size:16px;">Unit 06,18/F,Multifield Plaza, No. 3-7A Prat Avenue,Tsim Sha Tsui. Tel: (852) 5667 0493</td>
                    </tr>
                </tbody>
            </table>
            -->
        </div>
        </template>
        <div class="text e-info auto-table">
            <el-dialog title="借货" :visible.sync = "dialogTableVisible4" @close="closeSava"
                width="600px" center :close-on-click-modal="false">
                <el-form :inline="true" border label-width="150px" size="medium" 
                    :model="addDataForm4" class="demo-form-inline" ref="addDataForm4" :rules="rules4">
                    <el-form-item prop="islend" label="选择操作：">
                        <el-radio v-model="addDataForm4.islend" label="1" @click.native="selectChange1($event)">借货</el-radio>
                        <el-radio v-model="addDataForm4.islend" label="2" @click.native="selectChange2($event)">归还</el-radio>
                        <el-radio v-model="addDataForm4.islend" label="3" @click.native="selectChange2($event)">确认销售</el-radio>
                    </el-form-item><br>
                    <!--<el-form-item prop="sale_rate" label="订单汇率：">
                        <el-input v-model="addDataForm4.sale_rate" placeholder="请输入" :disabled="isdisabled"></el-input>
                    </el-form-item><br>
                    <el-form-item prop="sale_back" label="订单折扣：">
                        <el-input v-model="addDataForm4.sale_back" placeholder="请输入" :disabled="isdisabled"></el-input>
                    </el-form-item><br>-->
                    <el-form-item prop="vip" label="客户名称：">
                        <el-input v-model="addDataForm4.vip" placeholder="请输入" :disabled="isdisabled"></el-input>
                    </el-form-item><br>
                    <el-form-item prop="dateline" label="截止日期：">
                        <el-date-picker v-model="addDataForm4.dateline" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="截至日期" :disabled="isdisabled"></el-date-picker>
                    </el-form-item>
                    <el-form-item prop="remark" label="备注信息：">
                        <el-input v-model="addDataForm4.remark" placeholder="请输入" :disabled="isdisabled"></el-input>
                    </el-form-item><br>
                    <!--<span>&nbsp;&nbsp;注意：未上架货品借出，只有借出者可见</span>-->
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="savaDataParams4">保存并提交</el-button>
                </div>
            </el-dialog>
        </div>
        <div class="text e-info auto-table">
            <el-dialog title="全款借货" :visible.sync = "dialogTableVisible9" @close="closeSava"
                width="600px" center :close-on-click-modal="false">
                <el-form :inline="true" border label-width="150px" size="medium" 
                    :model="addDataForm3" class="demo-form-inline" ref="addDataForm3" :rules="rules3">
                    <el-form-item prop="islend" label="选择操作：">
                        <el-radio v-model="addDataForm3.islend" label="1" @click.native="selectChange1($event)">全款借货</el-radio>
                        <el-radio v-model="addDataForm3.islend" label="2" @click.native="selectChange2($event)">归还</el-radio>
                        <el-radio v-model="addDataForm3.islend" label="3" @click.native="selectChange2($event)">确认销售</el-radio>
                    </el-form-item><br>
                    <!--<el-form-item prop="sale_rate" label="订单汇率：">
                        <el-input v-model="addDataForm3.sale_rate" placeholder="请输入" :disabled="isdisabled"></el-input>
                    </el-form-item><br>
                    <el-form-item prop="sale_back" label="订单折扣：">
                        <el-input v-model="addDataForm3.sale_back" placeholder="请输入" :disabled="isdisabled"></el-input>
                    </el-form-item><br>-->
                    <el-form-item prop="clients" label="客户名称：">
                        <el-input v-model="addDataForm3.clients" placeholder="请输入" :disabled="isdisabled"></el-input>
                    </el-form-item><br>
                    <el-form-item prop="remark2" label="备注信息：">
                        <el-input v-model="addDataForm3.remark2" placeholder="请输入" :disabled="isdisabled"></el-input>
                    </el-form-item><br>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="savaDataParams6">保存并提交</el-button>
                </div>
            </el-dialog>
        </div>
        <div class="text e-info auto-table">
            <el-dialog title="批量作废" :visible.sync = "dialogTableVisible2"
                width="600px" center :close-on-click-modal="false">
                <span style="color: red; font-size: 18px;font-weight: bold;">是否确认进行批量作废{{data_len}}条数据！！！</span>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="dialogTableVisible2 = false">取消</el-button>
                    <el-button type="primary" @click="savaDataParams2">确认</el-button>
                </div>
            </el-dialog>
        </div>
        <div class="text e-info auto-table">
            <el-dialog title="批量退货" :visible.sync = "dialogTableVisible11"
                width="600px" center :close-on-click-modal="false">
                <span style="color: red; font-size: 18px;font-weight: bold;">是否确认进行批量退货！！！</span>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="dialogTableVisible11 = false">取消</el-button>
                    <el-button type="primary" @click="rebackEndOrders">确认</el-button>
                </div>
            </el-dialog>
        </div>
        <div class="text e-info auto-table">
            <el-dialog title="收款" :visible.sync = "dialogTableVisible3" @close="closeSava" 
                width="1480px" center :close-on-click-modal="false">
                <el-form :inline="true" label-width="100px" size="mini"
                        :model="shoukuanform" class="demo-form-inline" ref="shoukuanform">
                    <el-form-item prop="yh_zhekou" label="优惠折扣：" label-width="90px">
                        <el-input v-model="shoukuanform.yh_zhekou" placeholder="请输入" @change="yh_change"></el-input>
                    </el-form-item>
                    <el-table height="400" ref="refTable1" :data="dataOnLineListSelections"
                        show-summary :summary-method ="getSummaries_sk"
                        :header-cell-style="{background:'#eef1f6',color:'#606266'}">
                        <el-table-column align="center" width="80" prop="shape" label="形状"></el-table-column>
                        <el-table-column align="center" width="50" prop="ct" label="重量"></el-table-column>
                        <el-table-column align="center" width="50" prop="col" label="颜色"></el-table-column>
                        <el-table-column align="center" width="50" prop="cla" label="净度"></el-table-column>
                        <el-table-column align="center" width="50" prop="cut" label="切工"></el-table-column>
                        <el-table-column align="center" width="50" prop="pol" label="抛光"></el-table-column>
                        <el-table-column align="center" width="50" prop="sym" label="对称"></el-table-column>
                        <el-table-column align="center" width="50" prop="fl" label="荧光"></el-table-column>
                        <el-table-column align="center" width="80" prop="sale_rap" label="rap"></el-table-column>
                        <el-table-column align="center" width="140" prop="cert_no" label="证书号"></el-table-column>
                        <el-table-column align="center" width="80" prop="channel" label="渠道">
                            <template slot-scope="scope">
                                <el-form-item prop="channel" label-width="60px" style="margin-top:10px">
                                    <el-input v-model="scope.row.channel"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="100" prop="back" label="退点">
                            <template slot-scope="scope">
                                <el-form-item prop="back" label-width="50px" style="margin-top:10px">
                                    <el-input v-model="scope.row.back" oninput="value=value.replace(/[^-0-9.]/g,'')" 
                                        @input="handleInput1(scope.$index,scope.row.back)"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="80" prop="rate" label="汇率">
                            <template slot-scope="scope">
                                <el-form-item prop="rate" label-width="50px" style="margin-top:10px">
                                    <el-input v-model="scope.row.rate" oninput="value=value.replace(/[^-0-9.]/g,'')"
                                        @input="handleInput2(scope.$index,scope.row.rate)"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="110" prop="price" label="RMB">
                            <template slot-scope="scope">
                                <el-form-item prop="price" label-width="60px" style="margin-top:10px">
                                    <el-input v-model="scope.row.price" oninput="value=value.replace(/[^-0-9.]/g,'')"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="110" prop="received_r" label="实收">
                            <template slot-scope="scope">
                                <el-form-item prop="received_r" label-width="60px" style="margin-top:10px">
                                    <el-input v-model="scope.row.received_r" oninput="value=value.replace(/[^-0-9.]/g,'')"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="80" prop="beilv" label="倍率">
                            <template slot-scope="scope">
                                <el-form-item prop="beilv" label-width="50px" style="margin-top:10px">
                                    <el-input v-model="scope.row.beilv" min="1" oninput="value=value.replace(/[^-0-9.]/g,'')" 
                                        @input="handleInput3(scope.$index,scope.row.beilv)"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="110" prop="orders_usd" label="USD">
                            <template slot-scope="scope">
                                <el-form-item prop="orders_usd" label-width="60px" style="margin-top:10px">
                                    <el-input v-model="scope.row.orders_usd" oninput="value=value.replace(/[^-0-9.]/g,'')"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="110" prop="received_usd_r" label="实收USD">
                            <template slot-scope="scope">
                                <el-form-item prop="received_usd_r" label-width="60px" style="margin-top:10px">
                                    <el-input v-model="scope.row.received_usd_r" oninput="value=value.replace(/[^-0-9.]/g,'')"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        
                        <!--
                        <el-table-column align="center" width="120" prop="received_usd" label="实收USD">
                            <template slot-scope="scope">
                                <el-form-item prop="received_usd" label-width="60px" style="margin-top:10px">
                                    <el-input v-model="scope.row.received_usd" oninput="value=value.replace(/[^-0-9.]/g,'')"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        -->
                    </el-table>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="savaDataParams3">保存并提交</el-button>
                </div>
            </el-dialog>
        </div>
        <div class="text e-info auto-table">
            <el-dialog title="钻石报价" :visible.sync = "dialogTableVisible7" @close="closeSava" 
                width="1190px" center :close-on-click-modal="false">
                <el-form :inline="true" label-width="100px" size="mini"
                        :model="baojiaform" class="demo-form-inline" ref="baojiaform">
                    <el-form-item prop="all_new_dis" label="折扣加/减：" label-width="90px">
                        <el-input v-model="baojiaform.all_new_dis" placeholder="请输入" @change="dis_change"></el-input>
                    </el-form-item>
                    <el-form-item prop="all_sale_rate" label="销售汇率：" label-width="90px">
                        <el-input v-model="baojiaform.all_sale_rate" placeholder="请输入" @change="rate_change"></el-input>
                    </el-form-item>
                    <el-button type="primary" @click="selectCertnoCopy" plain size="small">带证书号复制</el-button>
                    <!--<el-button type="primary" @click="selectNoCertnoCopy" plain size="small">不带证书号</el-button>-->
                    <br><br>
                    <el-table height="400" ref="refTable1" :data="dataOnLineListSelections"
                        show-summary :summary-method ="getSummaries4"
                        :header-cell-style="{background:'#eef1f6',color:'#606266'}">
                        <el-table-column align="center" width="50" prop="shape" label="形状"></el-table-column>
                        <el-table-column align="center" width="50" prop="ct" label="重量"></el-table-column>
                        <el-table-column align="center" width="50" prop="col" label="颜色"></el-table-column>
                        <el-table-column align="center" width="50" prop="cla" label="净度"></el-table-column>
                        <el-table-column align="center" width="50" prop="cut" label="切工"></el-table-column>
                        <el-table-column align="center" width="50" prop="pol" label="抛光"></el-table-column>
                        <el-table-column align="center" width="50" prop="sym" label="对称"></el-table-column>
                        <el-table-column align="center" width="50" prop="fl" label="荧光"></el-table-column>
                        <el-table-column align="center" width="100" prop="sale_rap" label="rap"></el-table-column>
                        <el-table-column align="center" width="50" prop="cert" label="证书"></el-table-column>
                        <el-table-column align="center" width="150" prop="cert_no" label="证书号"></el-table-column>
                        <el-table-column align="center" width="100" prop="back" label="销售折扣">
                            <template slot-scope="scope">
                                <el-form-item prop="back" label-width="50px" style="margin-top:10px">
                                    <el-input v-model="scope.row.back" oninput="value=value.replace(/[^-0-9.]/g,'')" 
                                        @input="handleInput1(scope.$index,scope.row.back)"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="100" prop="rate" label="销售汇率">
                            <template slot-scope="scope">
                                <el-form-item prop="rate" label-width="50px" style="margin-top:10px">
                                    <el-input v-model="scope.row.rate"  oninput="value=value.replace(/[^-0-9.]/g,'')"
                                        @input="handleInput2(scope.$index,scope.row.rate)"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="120" prop="sale_price_r" label="RMB">
                            <template slot-scope="scope">
                                <el-form-item prop="sale_price_r" label-width="60px" style="margin-top:10px">
                                    <el-input v-model="scope.row.sale_price_r" oninput="value=value.replace(/[^-0-9.]/g,'')"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="120" prop="sale_usd_r" label="USD">
                            <template slot-scope="scope">
                                <el-form-item prop="sale_usd_r" label-width="60px" style="margin-top:10px">
                                    <el-input v-model="scope.row.sale_usd_r" oninput="value=value.replace(/[^-0-9.]/g,'')"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <!--<el-table-column align="center" width="120" prop="sale_price_r" label="RMB">
                            <template slot-scope="scope">
                                {{ Math.round(scope.row.sale_price_r) }}
                            </template>
                        </el-table-column>-->
                        <!--<el-table-column align="center" width="120" prop="sale_usd_r" label="USD">
                            <template slot-scope="scope">
                                {{ Math.round(scope.row.sale_usd_r) }}
                            </template>
                        </el-table-column>-->
                    </el-table>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="savaDataParams42">保存并提交</el-button>
                </div>
            </el-dialog>
        </div>
        <div class="text e-info auto-table">
            <el-dialog title="调整折扣" :visible.sync = "dialogTableVisible6" @close="closeSava" 
                width="600px" center :close-on-click-modal="false">
                <el-form :inline="true" label-width="150px" size="medium" 
                    :model="addDataForm5" class="demo-form-inline" ref="addDataForm5" :rules="rules5">
                    <el-form-item prop="new_dis" label="订单折扣：(加/减点)" >
                        <el-input v-model="addDataForm5.new_dis" placeholder="请输入" @change="handleInput5"></el-input>
                    </el-form-item>
                    <el-form-item prop="%" label="">
                        <span>%</span>
                    </el-form-item>
                    <el-form-item prop="price_all" label="总价格：" >
                        <el-input v-model="addDataForm5.price_all" readonly></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="savaDataParams40">保存并提交</el-button>
                </div>
            </el-dialog>
        </div>
        <div class="text e-info auto-table">
            <el-dialog title="调整汇率" :visible.sync = "dialogTableVisible5" @close="closeSava" 
                width="600px" center :close-on-click-modal="false">
                <el-form :inline="true" label-width="150px" size="medium" 
                    :model="addDataForm5" class="demo-form-inline" ref="addDataForm5" :rules="rules5">
                    <el-form-item prop="rate" label="订单汇率：">
                        <el-input v-model="addDataForm5.rate" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="savaDataParams41">保存并提交</el-button>
                </div>
            </el-dialog>
        </div>
        <div class="text e-info auto-table">
            <el-dialog title="批量删除" :visible.sync = "dialogTableVisible8" @close="closeSava" 
                width="600px" center :close-on-click-modal="false">
                <span>是否确认进行批量删除操作</span>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="dialogTableVisible8 = false">取消</el-button>
                    <el-button type="primary" @click="savaDataParams5">确认</el-button>
                </div>
            </el-dialog>
        </div>
        <div class="text e-info auto-table">
            <el-dialog title="修改信息" :visible.sync = "dialogTableVisible10" @close="closeSava" 
                center :close-on-click-modal="false" width="1300px" top="50px">
                <el-form :inline="true" label-width="110px" size="mini" :model="addDataForm" 
                        class="demo-form-inline" ref="addDataForm" :rules="rules">
                    <!--<el-form-item prop="stock_id" label="货号：">
                        <el-input style="width:180px;" v-model="addDataForm.stock_id" placeholder="请输入" readonly></el-input>
                    </el-form-item>-->
                    <el-form-item prop="cert_no" label="证书号：">
                        <el-input style="width:180px;" v-model="addDataForm.cert_no" placeholder="请输入" readonly></el-input>
                        <!--<el-button type="primary" @click="selectList">查询</el-button>-->
                    </el-form-item>
                    <el-form-item prop="other_no" label="编号：">
                        <el-input style="width:180px;" v-model="addDataForm.other_no" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item prop="place" label="地点：">
                        <el-select v-model="addDataForm.place" placeholder="请选择" style="width:180px">
                            <el-option v-for="item in placeList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="clients" label="客户名称：">
                        <el-input style="width:180px;" v-model="addDataForm.clients" placeholder="请输入"></el-input>
                    </el-form-item><br>
                    <!--
                    <el-form-item prop="supplier_rapid" label="供应商rapid：">
                        <el-input style="width:180px;" v-model="addDataForm.supplier_rapid" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item prop="supplier" label="供应商：">
                        <el-input style="width:180px;" v-model="addDataForm.supplier" placeholder="请输入"></el-input>
                    </el-form-item>
                    -->
                    <el-form-item prop="orders_usd" label="订单美金：">
                        <el-input style="width:180px;" v-model="addDataForm.orders_usd" 
                        @input="handleInput4(addDataForm.orders_usd)" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item prop="price" label="订单人民币：">
                        <el-input style="width:180px;" v-model="addDataForm.price" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item prop="rate" label="订单汇率：">
                        <el-input style="width:180px;" v-model="addDataForm.rate" 
                        @input="handleInput6(addDataForm.rate)" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item prop="back" label="订单折扣：">
                        <el-input style="width:180px;" v-model="addDataForm.back" 
                        @input="handleInput7(addDataForm.back)" placeholder="请输入"></el-input>
                    </el-form-item><br>
                    
                    <el-form-item prop="status" label="订单状态：">
                        <el-select v-model="addDataForm.status" placeholder="请选择" style="width:180px">
                            <el-option v-for="item in order_typeList" :key="item.value" :label="item.value" :value="item.value" disabled></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="received_type" label="款项：">
                        <el-select v-model="addDataForm.received_type" placeholder="请选择" style="width:180px">
                            <el-option v-for="item in received_typeList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <!--<el-form-item prop="price" label="应收金额：">
                        <el-input style="width:180px;" v-model="addDataForm.price" placeholder="请输入"></el-input>
                    </el-form-item>-->
                    <el-form-item prop="received" label="实收RMB：">
                        <el-input style="width:180px;" v-model="addDataForm.received" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item prop="received" label="实收USD：">
                        <el-input style="width:180px;" v-model="addDataForm.received_usd" placeholder="请输入"></el-input>
                    </el-form-item><br>
                    <el-form-item prop="cert" label="证书：">
                        <el-select v-model="addDataForm.cert" placeholder="请选择" style="width:180px">
                            <el-option v-for="item in certList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="deal_date" label="完成日期：">
                        <el-date-picker v-model="addDataForm.deal_date" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
                    </el-form-item>
                    <el-form-item prop="create_user" label="业务员：">
                        <el-input style="width:180px;" v-model="addDataForm.create_user" placeholder="请输入"></el-input>
                    </el-form-item>
                    <br>
                    <el-form-item prop="remark" label="备注：">
                        <el-input type="textarea" :autosize="{minRows:6, maxRows:3}" style="width:500px;"
                            placeholder="请输入内容" v-model="addDataForm.remark">
                        </el-input>
                    </el-form-item><br>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="closeSava">取 消</el-button>
                    <el-button type="primary" @click="savaDataParams">保存并提交</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
    import util from '../common/js/util';
    const cityOptions = ['D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M-N', 'O-Z', '<M'];
    import print from 'print-js'
    export default {
        data() {
            return {
                query1: {},
                isAble: true,
                isdisabled: false,
                checked: true,
                dialogTableVisible: false,
                dialogTableVisible1: false,
                dialogTableVisible2: false,
                dialogTableVisible3: false,
                dialogTableVisible4: false,
                dialogTableVisible5: false,
                dialogTableVisible6: false,
                dialogTableVisible7: false,
                dialogTableVisible8: false,
                dialogTableVisible9: false,
                dialogTableVisible10: false,
                dialogTableVisible11: false,
                checkboxGroup1: [],
                checkboxGroup2: [],
                checkboxGroup3: [],
                checkboxGroup4: [],
                checkboxGroup5: [],
                checkboxGroup6: [],
                checkboxGroup7: [],
                checkboxGroup8: [],
                checkboxGroup9: [],
                checkboxGroup10: [],
                statusOptions:[],
                statusStr:'',
                shapeList1: [{'value':'round'},{'value':'princess'},{'value':'radiant'}
                            ,{'value':'asscher'},{'value':'marquise'},{'value':'oval'}
                            ,{'value':'emerald'},{'value':'pear'},{'value':'heart'}
                            ,{'value':'cushion'},{'value':'others'},{'value':'triangle'}],
                shapeList: [{'value':'圆形'},{'value':'公主方'},{'value':'雷迪恩'}
                            ,{'value':'阿斯切'},{'value':'马眼'},{'value':'椭圆形'}
                            ,{'value':'祖母绿'},{'value':'梨形'},{'value':'心形'}
                            ,{'value':'垫形'},{'value':'其他'},{'value':'三角形'}],
                colList: [{'value':'D'},{'value':'E'},{'value':'F'}
                            ,{'value':'G'},{'value':'H'},{'value':'I'}
                            ,{'value':'J'},{'value':'K'},{'value':'L'}
                            ,{'value':'M-N'},{'value':'O-Z'}],
                claList: [{'value':'FL'},{'value':'IF'},{'value':'VVS1'}
                            ,{'value':'VVS2'},{'value':'VS1'},{'value':'VS2'}
                            ,{'value':'SI1'},{'value':'SI2'},{'value':'SI3'}
                            ,{'value':'I1'},{'value':'I2'}],
                cutList: [{'value':'EX'},{'value':'VG'},{'value':'GD'}
                            ,{'value':'FR'},{'value':'PR'},{'value':'NN'}],
                polList: [{'value':'EX'},{'value':'VG'},{'value':'GD'}
                            ,{'value':'FR'},{'value':'PR'}],
                flList: [{'value':'N'},{'value':'VSL'},{'value':'F'}
                            ,{'value':'M'},{'value':'S'},{'value':'VS'}],
                placeList: [{'value':'HK'},{'value':'CN'},{'value':'SZ'}
                            , {'value':'INDIA'},{'value':'LAB'},{'value':'SH'},{'value':'H-K'}],
                certList: [{'value':'GIA'},{'value':'NGTC'},{'value':'IGI'}
                            , {'value':'HRD'},{'value':'None'},{'value':'Other'}],
                order_typeList: [{'value':'保留'},{'value':'确认销售'},{'value':'已完成'}
                                ,{'value':'借货'},{'value':'全款借货'},{'value':'无效订单'}
                                ,{'value':'保留-已取消'},{'value':'借货-已取消'},{'value':'全款借货-已取消'}
                                ,{'value':'未完成'}],
                received_typeList: [{'value':'未收'},{'value':'收齐'}],
                colorlist: cityOptions,
                clalist: ['FL', 'IF', 'VVS1', 'VVS2', 'VS1', 'VS2', 'SI1', 'SI2', 'SI3', 'I1', 'I2'],
                cutlist: ['EX', 'VG', 'GD', 'FR', 'PR', 'NN'],
                pollist: ['EX', 'VG', 'GD', 'FR', 'PR'],
                fllist: ['N', 'VSL', 'F', 'M', 'S', 'VS'],
                certlist: ['GIA', 'NGTC', 'IGI', 'HRD', 'None', 'Other'],
                order_type: '',
                isq: '',
                inv_status: '',
                baojiaform: {},
                addDataForm: {},
                addDataForm2: {},
                addDataForm3: {},
                addDataForm4: {},
                addDataForm5: {},
                dataOnLineListSelections: [],
                printOrdersInfoList: [],
                clients_val: '',
                orders_val: '',
                other_val: '',
                od_ct:'',
                od_usd:'',
                certnoList: [],
                certnoStr: '',
                title_str: 'INVOICE',
                aimDiffBasicList: [{'project': '周报',
                    'ruleItemData':[{'project': '123'}]},
                    {'project': '周报','ruleItemData':[{'project': '123'}]}
                ],
                orderInfoList: [],
                orderAllInfoList: [],
                shoukuanform: {},
                data_len: 0,
                ct_total: 0,
                rmb_cost_total: 0,
                received_total: 0,
                received_usd_total:0,
                sale_price_total: 0,
                username: sessionStorage.getItem('userName'),
                // 查询
                query: {
                    data_dt: [],
                    ct1: '',
                    ct2: '',
                    order_type:'待取货',
                    danhao: '1',
                    huiyuan: '1'
                },
                // queryDate: '',
                queryDate: this.getNowTime(),
                // 分页
                pager: {
                    page: 1,
                    rows: 20,
                    total: 0
                },
                rules: {},
                rules31: {
                    status: [
                        {
                            required: true,
                            message: '请选择',
                            trigger: 'blur'
                        }
                    ],
                    received_type: [
                        {
                            required: true,
                            message: '请选择',
                            trigger: 'blur'
                        }
                    ],
                    received: [
                        {
                            required: true,
                            message: '请输入',
                            trigger: 'blur'
                        }
                    ],
                },
                rules3: {
                    date_long: [
                        {
                            required: true,
                            message: '请输入内容',
                            trigger: 'blur'
                        }
                    ],
                    clients: [
                        {
                            required: true,
                            message: '请输入内容',
                            trigger: 'blur'
                        }
                    ]
                },
                rules4: {
                    vip: [
                        {
                            required: true,
                            message: '请输入内容',
                            trigger: 'blur'
                        }
                    ],
                    /*dateline: [
                        {
                            required: true,
                            message: '请输入内容',
                            trigger: 'blur'
                        }
                    ]*/
                },
                rules5: {
                    rate: [
                        {
                            required: true,
                            message: '请输入',
                            trigger: 'blur'
                        }
                    ],
                    new_dis: [
                        {
                            required: true,
                            message: '请输入',
                            trigger: 'blur'
                        }
                    ]
                }
            };
        },
        methods: {
            // 选择行数
            sizeChange(rows) {
                this.pager.rows = rows;
                this.selectList();
            },
            // 选择页
            pageChange(page) {
                this.pager.page = page;
                this.selectList();
            },
            // shape 形状
            checkboxChange1(val) {
                this.query.shape = val.join();
                //console.log(this.query.shape);
            },
            // 颜色
            checkboxChange2(val) {
                this.query.col = val.join();
                //console.log(this.query.col);
            },
            // 净度
            checkboxChange3(val) {
                this.query.cla = val.join();
                //console.log(this.query.col);
            },
            // 切工
            checkboxChange4(val) {
                this.query.cut = val.join();
                //console.log(this.query.cut);
            },
            // 抛光
            checkboxChange5(val) {
                this.query.pol = val.join();
                //console.log(this.query.pol);
            },
            // 对称
            checkboxChange6(val) {
                this.query.sym = val.join();
                //console.log(this.query.sym);
            },
            // 荧光
            checkboxChange7(val) {
                this.query.fl = val.join();
                //console.log(this.query.fl);
            },
            // 证书
            checkboxChange8(val) {
                this.query.cert = val.join();
                //console.log(this.query.cert);
            },
            // 销售状态
            checkboxChange9(val) {
                this.query.sale_status = val.join();
                //console.log(this.query.sale_status);
            },
            // 联动赋值重量
            ctChange(val) {
                if(val == 3) {
                    this.$set(this.query,'ct1','0.30');
                    this.$set(this.query,'ct2','0.39');
                }else if(val == 4) {
                    this.$set(this.query,'ct1','0.40');
                    this.$set(this.query,'ct2','0.49');
                }else if(val == 5) {
                    this.$set(this.query,'ct1','0.50');
                    this.$set(this.query,'ct2','0.59');
                }else if(val == 6) {
                    this.$set(this.query,'ct1','0.60');
                    this.$set(this.query,'ct2','0.69');
                }else if(val == 7) {
                    this.$set(this.query,'ct1','0.70');
                    this.$set(this.query,'ct2','0.79');
                }else if(val == 8) {
                    this.$set(this.query,'ct1','0.80');
                    this.$set(this.query,'ct2','0.89');
                }else if(val == 9) {
                    this.$set(this.query,'ct1','0.90');
                    this.$set(this.query,'ct2','0.99');
                }else if(val == 10) {
                    this.$set(this.query,'ct1','1.00');
                    this.$set(this.query,'ct2','1.09');
                }else if(val == 11) {
                    this.$set(this.query,'ct1','1.10');
                    this.$set(this.query,'ct2','1.49');
                }else if(val == 12) {
                    this.$set(this.query,'ct1','1.50');
                    this.$set(this.query,'ct2','1.99');
                }else if(val == 13) {
                    this.$set(this.query,'ct1','2.00');
                    this.$set(this.query,'ct2','2.99');
                }else if(val == 14) {
                    this.$set(this.query,'ct1','3.00');
                    this.$set(this.query,'ct2','3.99');
                }else if(val == 15) {
                    this.$set(this.query,'ct1','4.00');
                    this.$set(this.query,'ct2','4.99');
                }else if(val == 16) {
                    this.$set(this.query,'ct1','5.00');
                    this.$set(this.query,'ct2','9.99');
                }
            },
            // 手动输入重量
            ctSelect(e) {
                let value = e.target.value;
                if (value) {
                    if (value.includes('-')) {
                        this.$nextTick(()=> {
                            this.$set(this.query,'ct',value);
                        })
                        let valArr = value.split('-');
                        this.$set(this.query, 'ct1', valArr[0]);
                        this.$set(this.query, 'ct2', valArr[1]);
                        console.log(this.query.ct1);
                        console.log(this.query.ct2);
                    }
                }
            },
            // 手动输入重量2
            ctChange3(value) {
                if(value) {
                    this.$set(this.query,'ct','');
                    console.log(value)
                    this.$set(this.query,'ct1',value);
                    console.log(this.query.ct1);
                }
            },
            ctChange4(value) {
                if(value) {
                    console.log(value)
                    this.$set(this.query,'ct2',value);
                    console.log(this.query.ct2);
                }
            },
            // 3EXN
            select3exn() {
                this.checkboxGroup4 = ['EX'];
                this.checkboxGroup5 = ['EX'];
                this.checkboxGroup6 = ['EX'];
                this.checkboxGroup7 = ['N'];
                this.query.cut = 'EX';
                this.query.pol = 'EX';
                this.query.sym = 'EX';
                this.query.fl = 'N';
            },
            // EXN
            selectexn() {
                this.checkboxGroup4 = ['EX'];
                this.checkboxGroup5 = ['EX', 'VG'];
                this.checkboxGroup6 = ['EX', 'VG'];
                this.checkboxGroup7 = ['N'];
                this.query.cut = 'EX';
                this.query.pol = 'EX,VG';
                this.query.sym = 'EX,VG';
                this.query.fl = 'N';
            },
            // VGN
            selectvgn() {
                this.checkboxGroup4 = ['VG'];
                this.checkboxGroup5 = ['EX', 'VG'];
                this.checkboxGroup6 = ['EX', 'VG'];
                this.checkboxGroup7 = ['N'];
                this.query.cut = 'VG';
                this.query.pol = 'EX,VG';
                this.query.sym = 'EX,VG';
                this.query.fl = 'N';
            },
            selectChange1(el) {
                if (el.target.tagName === 'INPUT') {
                    return;
                }
                this.isdisabled = false;
            },
            selectChange2(el) {
                if (el.target.tagName === 'INPUT') {
                    return;
                }
                this.isdisabled = true;
            },
            // 订单状态多选
            getStatusOptions(statusArr) {
                this.statusStr = statusArr.join(',');
                //console.log(this.statusStr)
            },
            // 双击展开行
            toggleExpand(row) {
                this.$refs.refTable.toggleRowExpansion(row);
            },
            // 选择器选择数据，加工数据证书号
            selectionLineChangeHandle(val) {
                //console.log(val);
                // 选中的值赋给要打印的LIST
                this.printOrdersInfoList = val;
                this.printOrdersInfoList.forEach(item =>{this.$set(item,'orders_usd_r',Math.round(item.orders_usd))})
                this.printOrdersInfoList.forEach(item =>{this.$set(item,'price_r',Math.round(item.price))})
                //this.printOrdersInfoList.forEach(item =>{this.$set(item,'received_r',Math.round(item.price))})
                //this.printOrdersInfoList.forEach(item =>{this.$set(item,'received_usd',Math.round(item.orders_usd))})
                if (val.length > 0) {
                    //console.log(val[0].clients);
                    this.clients_val = val[0].clients;
                    this.orders_val = val[0].orders_no;
                    this.other_val = val[0].other_no;
                }
                // 统计选中数量
                this.data_len = val.length;
                // 计算总销售额
                let rmb_cost1 = 0;
                let received1 = 0;
                let received_usd1 = 0;
                let sale_price1 = 0;
                let orders_usd1 = 0;
                let ct1 = 0;
                let sale_rate = 7.9
                for (let a = 0; a<this.data_len; a++) {
                    //console.log(val[0].sale_price);
                    // 进货价
                    rmb_cost1 += Math.round(val[a].rmb_cost);
                    // 销售rmb
                    sale_price1 += Math.round(val[a].price);
                    // 销售美金
                    orders_usd1 += Math.round(val[a].orders_usd);
                    // 实收RMB
                    received1 += Math.round(val[a].received);
                    // 重量
                    ct1 += parseFloat(val[a].ct);
                    //收款的实收RMB设值
                    let received_r = Number(this.printOrdersInfoList[a].received);
                    
                    if(!this.printOrdersInfoList[a].received){
                        if(this.printOrdersInfoList[a].place === 'HK' || this.printOrdersInfoList[a].place === 'H-K'){
                            received_r = received_usd_r
                        }
                    }
                    
                    if(received_r !== 0){
                        this.$set(this.printOrdersInfoList[a],'received_r',received_r)
                    }else{
                        this.$set(this.printOrdersInfoList[a],'received_r',val[a].price)
                    }

                    // 实收USD
                    if(!this.printOrdersInfoList[a].received_usd){
                        this.$set(this.printOrdersInfoList[a],'received_usd',val[a].orders_usd);
                    }
                    // 实收USD
                    received_usd1 += parseFloat(this.printOrdersInfoList[a].received_usd);
                    //实收USD设置
                    let received_usd_r = Number(this.printOrdersInfoList[a].received_usd);
                    
                    if(received_usd_r){
                        this.$set(this.printOrdersInfoList[a],'received_usd_r',received_usd_r)
                    }else{
                        this.$set(this.printOrdersInfoList[a],'received_usd_r',val[a].orders_usd)
                    }

                    // 汇率为空。设置为7.9 并且计算人民币和实收值
                    if(!this.printOrdersInfoList[a].rate){
                        this.$set(this.printOrdersInfoList[a],'rate',sale_rate)
                        let price = (sale_rate * val[a].orders_usd).toFixed(2)
                        this.$set(this.printOrdersInfoList[a],'price',price)
                        this.$set(this.printOrdersInfoList[a],'received_r',price)
                    }

                    // 倍率为空 设置为1
                    if(!this.printOrdersInfoList[a].beilv){
                        this.$set(this.printOrdersInfoList[a],'beilv',1)
                    }
                    
                    // 渠道为空 设置默认 空
                    if(!this.printOrdersInfoList[a].channel){
                        this.$set(this.printOrdersInfoList[a],'channel','')
                    }
                    
                    // 打印订单数据
                    this.od_ct = ct1.toFixed(2);
                    this.od_usd = Math.round(received_usd1);
                }
                // 设置折扣调整的总价
                this.$set(this.addDataForm5, 'price_all', sale_price1);
                // 进货价
                this.rmb_cost_total = rmb_cost1.toFixed(2);
                // 销售价格
                this.received_total = received1.toFixed(2);
                // 美金实收
                this.received_usd_total = received_usd1.toFixed(2);
                this.sale_price_total = sale_price1.toFixed(2);
                // 总重量
                this.ct_total = ct1.toFixed(2);
                // 选中导出数据赋值
                this.dataOnLineListSelections = val;
                this.dataOnLineListSelections.forEach(item =>{this.$set(item,'sale_usd_r',Math.round(item.orders_usd))})
                this.dataOnLineListSelections.forEach(item =>{this.$set(item,'sale_price_r',Math.round(item.price))})
                // 复制选中数据给客户
                //for (let i = 0; i < this.data_len; i++) {
                //    console.log(val[i]);
                //}
                // id、数据证书号拼接
                this.idList = val.map((item) => item.id);
                this.certnoList = val.map((item) => item.cert_no + '\n');
                this.sale_priceList = val.map((item) => item.price);
                // 数据选中后，显示按钮
                if (this.certnoList.length > 0) {
                    this.isAble = false;
                } else {
                    this.isAble = true;
                }
                // 借货默认设置状态
                this.$set(this.addDataForm4, 'islend', '1');
                // 全款借货默认设置状态
                this.$set(this.addDataForm3, 'islend', '1');
                if(this.dataOnLineListSelections.length>0){
                    // 设置借货默认客户名称
                    this.$set(this.addDataForm4,'vip',this.dataOnLineListSelections[0].clients);
                    // 设置全款借货默认客户名称
                    this.$set(this.addDataForm3,'clients',this.dataOnLineListSelections[0].clients);
                }
            },
            // 钻石报价批量修改折扣
            dis_change(value){
                if(value>3 || value<-3){
                    this.errorMsg("警告，折扣修改大于3个点，请重新输入！");
                    this.$set(this.baojiaform, 'all_new_dis', '');
                    return;
                }
                for(let row = 0; row < this.dataOnLineListSelections.length; row++) {
                    // 销售美金 = 销售rap * (1+新折扣%) *重量
                    // 销售价格 = 销售美金 * 销售汇率
                    //console.log(this.dataOnLineListSelections[row])
                    let sale_rap = this.dataOnLineListSelections[row].sale_rap
                    let sale_rate = this.dataOnLineListSelections[row].rate
                    let new_dis = this.dataOnLineListSelections[row].back
                    let ct = this.dataOnLineListSelections[row].ct
                    let beilv = this.dataOnLineListSelections[row].beilv
                    if(value){
                        new_dis = parseFloat(new_dis) + parseFloat(value)
                    }
                    let sale_usd = (sale_rap*(1+(new_dis/100)) *ct).toFixed(2)
                    let sale_price = (beilv * sale_rate * sale_usd).toFixed(2)
                    this.$set(this.dataOnLineListSelections[row],'back',new_dis)
                    this.$set(this.dataOnLineListSelections[row],'price',Math.round(sale_price))
                    this.$set(this.dataOnLineListSelections[row],'orders_usd',sale_usd)
                    this.$set(this.dataOnLineListSelections[row],'sale_price_r',Math.round(sale_price))
                    this.$set(this.dataOnLineListSelections[row],'sale_usd_r',Math.round(sale_usd))
                }
            },
            // 钻石报价批量修改汇率
            rate_change(value){
                for(let row = 0; row < this.dataOnLineListSelections.length; row++) {
                    // 销售美金 = 销售rap * (1+新折扣%) *重量
                    // 销售价格 = 销售美金 * 销售汇率
                    //console.log(this.dataOnLineListSelections[row])
                    let sale_rap = this.dataOnLineListSelections[row].sale_rap
                    let sale_rate = this.dataOnLineListSelections[row].rate
                    let new_dis = this.dataOnLineListSelections[row].back
                    let ct = this.dataOnLineListSelections[row].ct
                    let beilv = this.dataOnLineListSelections[row].beilv
                    if(value){
                        sale_rate = value
                    }
                    let sale_usd = (sale_rap*(1+(new_dis/100)) *ct).toFixed(2)
                    let sale_price = (beilv * sale_rate * sale_usd).toFixed(2)
                    this.$set(this.dataOnLineListSelections[row],'rate',sale_rate)
                    this.$set(this.dataOnLineListSelections[row],'price',Math.round(sale_price))
                    this.$set(this.dataOnLineListSelections[row],'orders_usd',sale_usd)
                    this.$set(this.dataOnLineListSelections[row],'sale_price_r',Math.round(sale_price))
                    this.$set(this.dataOnLineListSelections[row],'sale_usd_r',Math.round(sale_usd))
                }
            },
            // 收款优惠折扣
            yh_change(value){
                for(let row = 0; row < this.dataOnLineListSelections.length; row++) {
                    // 销售美金 = 销售rap * (1+新折扣%) *重量
                    // 销售价格 = 销售美金 * 销售汇率
                    //console.log(this.dataOnLineListSelections[row])
                    if((parseFloat(this.dataOnLineListSelections[row].beilv) - parseFloat(value)) == 0){
                        console.log(this.dataOnLineListSelections[row].beilv)
                        console.log(value)
                        continue;
                    }
                    let sale_rap = this.dataOnLineListSelections[row].sale_rap
                    let sale_rate = this.dataOnLineListSelections[row].rate
                    let orders_usd = this.dataOnLineListSelections[row].orders_usd
                    //let new_dis = this.dataOnLineListSelections[row].back
                    let ct = this.dataOnLineListSelections[row].ct
                    if(!value){
                        value = 1
                    }
                    // USD
                    //let sale_usd = (sale_rap*(1+(new_dis/100)) * ct).toFixed(2)
                    // 实收USD 美金 * 倍率 就是折扣
                    let yh_usd = (orders_usd * value).toFixed(2)
                    // 反算折扣
                    let dis = ((yh_usd / ct / sale_rap - 1) * 100).toFixed(2)
                    // 实收rmb
                    let sale_price =  Math.round((sale_rate * yh_usd).toFixed(2));
                    // 实收rmb
                    this.$set(this.dataOnLineListSelections[row], 'received_r', sale_price);
                    this.$set(this.dataOnLineListSelections[row],'back',dis)
                    //this.$set(this.dataOnLineListSelections[row],'orders_usd',Math.round(sale_usd))
                    this.$set(this.dataOnLineListSelections[row],'received_usd_r',yh_usd)
                    this.$set(this.dataOnLineListSelections[row],'beilv',value)
                    // 钻石报价的美金价
                    //this.$set(this.dataOnLineListSelections[row],'sale_usd_r',Math.round(sale_usd))
                    /*
                    if(this.dataOnLineListSelections[row].place === 'HK' || this.dataOnLineListSelections[row].place === 'H-K'){
                        this.$set(this.dataOnLineListSelections[row], 'received_r', yh_usd);
                    }
                    */
                }
            },
            // 修改 倍率
            handleInput3(row,val) {
                console.log(val)
                let sale_rap = this.dataOnLineListSelections[row].sale_rap
                let sale_rate = this.dataOnLineListSelections[row].rate
                let orders_usd = this.dataOnLineListSelections[row].orders_usd
                //let new_dis = this.dataOnLineListSelections[row].back
                let ct = this.dataOnLineListSelections[row].ct
                if(!val){
                    val = 1
                }
                // USD
                // let sale_usd = (sale_rap*(1+(new_dis/100)) * ct).toFixed(2)
                // 实收USD 美金 * 倍率 就是折扣
                let yh_usd = (orders_usd * val).toFixed(2)
                // 反算折扣
                let dis = ((yh_usd / ct / sale_rap - 1) * 100).toFixed(2)
                // 实收rmb
                let sale_price =  Math.round((sale_rate * yh_usd).toFixed(2));
                // 实收rmb
                this.$set(this.dataOnLineListSelections[row], 'received_r', sale_price);
                this.$set(this.dataOnLineListSelections[row],'back',dis)
                //this.$set(this.dataOnLineListSelections[row],'orders_usd',Math.round(sale_usd))
                this.$set(this.dataOnLineListSelections[row],'received_usd_r',yh_usd)
                this.$set(this.dataOnLineListSelections[row],'beilv',value)
                // 钻石报价的美金价
                //this.$set(this.dataOnLineListSelections[row],'sale_usd_r',Math.round(sale_usd))
                /*
                if(this.dataOnLineListSelections[row].place === 'HK' || this.dataOnLineListSelections[row].place === 'H-K'){
                    this.$set(this.dataOnLineListSelections[row], 'received_r', yh_usd);
                }
                */
            },
            // 修改订单退点
            handleInput1(row, val) {
                console.log(row);
                console.log(val);
                // 销售美金 = 销售rap * (1+新折扣%) *重量
                // 销售价格 = 销售美金 * 销售汇率
                let sale_rap = this.dataOnLineListSelections[row].sale_rap;
                let sale_rate = this.dataOnLineListSelections[row].rate;
                let ct = this.dataOnLineListSelections[row].ct;
                let orders_usd = (sale_rap * (1 + (val / 100)) * ct).toFixed(2);
                let sale_price =  Math.round((sale_rate * sale_rap * (1 + (val / 100)) * ct).toFixed(2));
                // 收款
                this.$set(this.dataOnLineListSelections[row], 'price', sale_price);
                this.$set(this.dataOnLineListSelections[row], 'orders_usd', orders_usd);
                this.$set(this.dataOnLineListSelections[row], 'received_r', sale_price);
                this.$set(this.dataOnLineListSelections[row],'received_usd_r',orders_usd)
                /*
                if(this.dataOnLineListSelections[row].place === 'HK' || this.dataOnLineListSelections[row].place === 'H-K'){
                    this.$set(this.dataOnLineListSelections[row], 'received_r', orders_usd);
                }
                */
                // 调价
                this.$set(this.dataOnLineListSelections[row], 'sale_price_r', sale_price);
                this.$set(this.dataOnLineListSelections[row], 'sale_usd_r', orders_usd);
            },
            // 修改订单汇率
            handleInput2(row, val) {
                console.log(row);
                console.log(val);
                // 销售美金 = 销售rap * (1+新折扣%) *重量
                // 销售价格 = 销售美金 * 销售汇率
                // let orders_usd = this.dataOnLineListSelections[row].orders_usd;
                let sale_rap = this.dataOnLineListSelections[row].sale_rap;
                let new_dis = this.dataOnLineListSelections[row].back;
                let ct = this.dataOnLineListSelections[row].ct;
                let orders_usd = (sale_rap * (1+(new_dis / 100)) * ct).toFixed(2);
                let sale_price = Math.round((val * orders_usd).toFixed(2));
                // 收款
                this.$set(this.dataOnLineListSelections[row], 'price', sale_price);
                this.$set(this.dataOnLineListSelections[row], 'orders_usd', orders_usd);
                this.$set(this.dataOnLineListSelections[row], 'received_r', sale_price);
                this.$set(this.dataOnLineListSelections[row], 'rate', val);
                this.$set(this.dataOnLineListSelections[row],'received_usd_r',orders_usd);
                /*
                if(this.dataOnLineListSelections[row].place === 'HK' || this.dataOnLineListSelections[row].place === 'H-K'){
                    this.$set(this.dataOnLineListSelections[row], 'received_r', orders_usd);
                }
                */
                // 调价
                this.$set(this.dataOnLineListSelections[row], 'sale_price_r', sale_price);
                this.$set(this.dataOnLineListSelections[row], 'sale_usd_r', orders_usd);
            },
            // 修改订单美金
            handleInput4(val) {
                console.log(val);
                // 销售美金 = 销售rap * (1+新折扣%) *重量
                // 销售价格 = 销售美金 * 销售汇率
                let price = (val * this.addDataForm.rate).toFixed(2);
                console.log(price);
                this.$set(this.addDataForm, 'price', price);
            },
            // 修改订单汇率
            handleInput6(val) {
                console.log(val);
                // 销售美金 = 销售rap * (1+新折扣%) *重量
                // 销售价格 = 销售美金 * 销售汇率
                let price = (val * this.addDataForm.orders_usd).toFixed(2);
                console.log(price);
                this.$set(this.addDataForm, 'price', price);
            },
            // 修改订单折扣
            handleInput7(val) {
                console.log(val);
                // 销售美金 = 销售rap * (1+新折扣%) *重量
                let orders_usd = this.addDataForm.sale_rap * (1 + (val / 100)) * this.addDataForm.ct;
                // 销售价格 = 销售美金 * 销售汇率
                let price = (orders_usd * this.addDataForm.rate).toFixed(2);
                console.log(price);
                this.$set(this.addDataForm, 'price', price);
            },
            // 修改折扣 设置总价
            handleInput5(value) {
                console.log(value);
                let price_all = 0;
                for(let row = 0; row < this.dataOnLineListSelections.length; row++) {
                    // 销售美金 = 销售rap * (1+新折扣%) *重量
                    // 销售价格 = 销售美金 * 销售汇率
                    //console.log(this.dataOnLineListSelections[row])
                    let sale_rap = this.dataOnLineListSelections[row].sale_rap
                    let sale_rate = this.dataOnLineListSelections[row].rate
                    let new_dis = this.dataOnLineListSelections[row].back
                    let ct = this.dataOnLineListSelections[row].ct
                    if(value){
                        new_dis = parseFloat(new_dis) + parseFloat(value)
                    }
                    let sale_usd = (sale_rap*(1+(new_dis/100)) *ct).toFixed(2)
                    let sale_price = (sale_rate * sale_usd).toFixed(2)
                    console.log(sale_usd)
                    console.log(sale_price)
                    price_all = parseFloat(price_all) + parseFloat(sale_price)
                    //this.$set(this.dataOnLineListSelections[row],'new_dis',new_dis)
                    //this.$set(this.dataOnLineListSelections[row],'sale_price',sale_price)
                    //this.$set(this.dataOnLineListSelections[row],'sale_usd',sale_usd)
                    //this.$set(this.dataOnLineListSelections[row],'sale_price_r',Math.round(sale_price))
                    //this.$set(this.dataOnLineListSelections[row],'sale_usd_r',Math.round(sale_usd))
                }
                this.$set(this.addDataForm5, 'price_all', price_all);
            },
            // 获取证书号
            selectCertno() {
                this.certnoStr = this.certnoList.join(',');
                this.certnoStr = this.certnoStr.replaceAll(',', '');
                // this.dialogTableVisible = true;
                // 复制
                this.copyText(this.certnoStr);
            },
            copyText(val) {
                // 存储传递过来的数据
                // let userId = sessionStorage.getItem("userId");
                // createElement() 方法通过指定名称创建一个元素
                let newInput = document.createElement('textarea');
                // 讲存储的数据赋值给input的value值
                newInput.value = val;
                // appendChild() 方法向节点添加最后一个子节点
                document.body.appendChild(newInput);
                // select() 方法用于选择该元素中的文本
                newInput.select();
                // execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
                document.execCommand('Copy');
                // 清空输入框
                newInput.remove();
                // 下面是element的弹窗 不需要的自行删除就好
                this.$message({
                    message: '复制成功',
                    type: 'success',
                });
            },
            // 打印订单
            printOrders() {
                print({ printable: 'printJS-form',
                    type: 'html',
                    // header: '深圳乐蒂斯珠宝有限公司',
                    // header: '出货单明细',
                    header: `<div style="display:flex; flex-direction:column; text-align:center; font-size:18px">
                                <h3>深圳乐蒂斯珠宝有限公司</h3>
                                <h3>出货单明细</h3>
                            </div>`,
                    headerStyle: 'text-align:center;width:100%;',
                    
                    // targetStyles: ['border', 'padding: 15px'],
                    documentTitle: 'lds',
                    scanStyles: false,
                    style: `@page {size:auto;margin-top:50px; margin-left:15px; margin-right: 15px;}
                        thead th {
                        border-top: 1px solid #000;
                        border-right: 1px solid #000;
                        border-left: 1px solid #000;
                        line-height: 30px;
                        font-size: 20px;
                        }
                        tbody td {
                        border: 1px solid #000;
                        }
                        tbody {
                        text-align: center;
                        line-height: 30px;
                        }
                        table {
                        border-collapse: collapse;
                        }`,
                    onLoadingStart: () => {
                        document.getElementById("printJS-form").style.display = '';// 显示
                        console.log('打印开始');
                    },
                    onLoadingEnd: () => {
                        document.getElementById("printJS-form").style.display = 'none';// 隐藏
                        console.log('打印完成');
                    }
                    //style: 'table tr td,th { border-collapse: collapse;padding: 15px;border:1px #000 solid; }' // 表格样式
                });
            },
            // 计算汇总求和
            getSummaries(param) {
                // param 是固定的对象，里面包含 columns与 data参数的对象 {columns: Array[4], data: Array[5]},包含了表格的所有的列与数据信息
                const { columns, data } = param;
                // console.log(param);
                // console.log(data)
                const sums = [];
                columns.forEach((column, index) => {
                    // console.log(column)
                    // console.log(index)
                    if (index === 0) {
                        sums[index] = '合计';
                        return;
                    }
                    if (index === 3) {
                        const values = data.map(item => Number(item[column.property]));
                        // 验证每个value值是否是数字，如果是执行if
                        if (!values.every(value => isNaN(value))) {
                            sums[index] = values.reduce((prev, curr) => {
                            // const value = Number(curr);
                            // if (!isNaN(value)) {
                            return prev + curr;
                            // } else {
                            //   return prev;
                            // }
                            }, 0);
                            sums[index] = sums[index].toFixed(2);
                        } else {
                            sums[index] = 'N/A';
                        }
                    }
                    if (index === 14) {
                        const values = data.map(item => Number(item[column.property]));
                        // 验证每个value值是否是数字，如果是执行if
                        if (!values.every(value => isNaN(value))) {
                            sums[index] = values.reduce((prev, curr) => {
                            // const value = Number(curr);
                            // if (!isNaN(value)) {
                            return prev + curr;
                            // } else {
                            //   return prev;
                            // }
                            }, 0);
                            sums[index] = Math.round(sums[index]);
                            sums[index] += ' 元';
                        } else {
                            sums[index] = 'N/A';
                        }
                    }
                });
                return sums;
            },
            // 计算汇总求和
            getSummaries5(param) {
                // param 是固定的对象，里面包含 columns与 data参数的对象 {columns: Array[4], data: Array[5]},包含了表格的所有的列与数据信息
                const { columns, data } = param;
                // console.log(param);
                // console.log(data)
                const sums = [];
                columns.forEach((column, index) => {
                    // console.log(column)
                    // console.log(index)
                    if (index === 0) {
                        sums[index] = 'Total';
                        return;
                    }
                    if (index === 1) {
                        sums[index] = this.data_len;
                        sums[index] += ' pcs';
                    }
                    if (index === 2) {
                        const values = data.map(item => Number(item[column.property]));
                        // 验证每个value值是否是数字，如果是执行if
                        if (!values.every(value => isNaN(value))) {
                            sums[index] = values.reduce((prev, curr) => {
                            // const value = Number(curr);
                            // if (!isNaN(value)) {
                            return prev + curr;
                            // } else {
                            //   return prev;
                            // }
                            }, 0);
                            sums[index] = sums[index].toFixed(2);
                        } else {
                            sums[index] = 'N/A';
                        }
                    }
                    if (index === 12) {
                        sums[index] = this.od_usd;
                        sums[index] += ' $';
                    }
                });
                return sums;
            },
            // 打印订单
            printOrdersInvoice() {
                //this.title_str = 'INVOICE';
                print({ printable: 'printJS-form2',
                    type: 'html',
                    // header: '深圳乐蒂斯珠宝有限公司',
                    header: `<div style="display:flex; flex-direction:column; text-align:center">
                                <h1>KABO UNIVERSAL LIMITED</h1>
                                <h3>Room 8 12/F Tower B <br>Hunghom Commercial Centre <br>37-39 Ma Tau Wai Road Hung Hom Kowloon <br>Tel : +852 5118 4962</h3>
                            </div>`,
                    headerStyle: 'text-align:center;width:100%;',
                    // targetStyles: ['border', 'padding: 15px'],
                    documentTitle: 'Kabo',
                    scanStyles: false,
                    style: `@page {size:auto;margin-top:50px; margin-left:15px; margin-right: 15px;}
                        thead th {
                            border-top: 1px solid #000;
                            border-right: 1px solid #000;
                            border-left: 1px solid #000;
                            line-height: 20px;
                            font-size: 12px;
                        }
                        tbody td {
                            border: 1px solid #000;
                        }
                        tbody {
                            text-align: center;
                            line-height: 20px;
                        }
                        table {
                            border-collapse: collapse;
                        }
                        `,
                    onLoadingStart: () => {
                        document.getElementById("span_t1").style.display = '';// 显示
                        document.getElementById("span_t2").style.display = 'none';// 隐藏
                        document.getElementById("table_t1").style.display = '';// 显示
                        document.getElementById("table_t2").style.display = 'none';// 隐藏
                        document.getElementById("table_t11").style.display = '';// 显示
                        document.getElementById("table_t22").style.display = 'none';// 隐藏
                        document.getElementById("printJS-form2").style.display = '';// 显示
                        console.log('打印开始');
                    },
                    onLoadingEnd: () => {
                        document.getElementById("printJS-form2").style.display = 'none';// 隐藏
                        console.log('打印完成');
                    }
                    //style: 'table tr td,th { border-collapse: collapse;padding: 15px;border:1px #000 solid; }' // 表格样式
                });
            },
            // 打印订单 有BR
            printOrdersInvoiceBR() {
                //this.title_str = 'INVOICE';
                print({ printable: 'printJS-form2',
                    type: 'html',
                    // header: '深圳乐蒂斯珠宝有限公司',
                    header: `<div style="display:flex; flex-direction:column; text-align:center">
                                <h3>X-Z Jewellery HK Limited</h3>
                                <h3>尋鑽珠寶香港有限公司</h3>
                            </div>`,
                    headerStyle: 'text-align:center;width:100%;',
                    // targetStyles: ['border', 'padding: 15px'],
                    documentTitle: 'X-Z',
                    scanStyles: false,
                    style: `@page {size:auto;margin-top:50px; margin-left:15px; margin-right: 15px;}
                        thead th {
                            border-top: 1px solid #000;
                            border-right: 1px solid #000;
                            border-left: 1px solid #000;
                            line-height: 20px;
                            font-size: 12px;
                        }
                        tbody td {
                            border: 1px solid #000;
                        }
                        tbody {
                            text-align: center;
                            line-height: 20px;
                        }
                        table {
                            border-collapse: collapse;
                        }
                        `,
                    onLoadingStart: () => {
                        document.getElementById("span_t1").style.display = '';// 显示
                        document.getElementById("span_t2").style.display = 'none';// 隐藏
                        document.getElementById("table_t1").style.display = 'none';// 隐藏
                        document.getElementById("table_t2").style.display = '';// 显示
                        document.getElementById("printJS-form2").style.display = '';// 显示
                        console.log('打印开始');
                    },
                    onLoadingEnd: () => {
                        document.getElementById("printJS-form2").style.display = 'none';// 隐藏
                        console.log('打印完成');
                    }
                    //style: 'table tr td,th { border-collapse: collapse;padding: 15px;border:1px #000 solid; }' // 表格样式
                });
            },
            // 打印订单
            printOrdersCashMemo() {
                //this.title_str = 'CASH MEMO';
                print({ printable: 'printJS-form2',
                    type: 'html',
                    // header: '深圳乐蒂斯珠宝有限公司',
                    header: `<div style="display:flex; flex-direction:column; text-align:center">
                                <h1>KABO UNIVERSAL LIMITED</h1>
                                <h3>Room 8 12/F Tower B <br>Hunghom Commercial Centre <br>37-39 Ma Tau Wai Road Hung Hom Kowloon <br>Tel : +852 5118 4962</h3>
                            </div>`,
                    headerStyle: 'text-align:center;width:100%;',
                    // targetStyles: ['border', 'padding: 15px'],
                    documentTitle: 'X-Z',
                    scanStyles: false,
                    style: `@page {size:auto;margin-top:50px; margin-left:15px; margin-right: 15px;}
                        thead th {
                            border-top: 1px solid #000;
                            border-right: 1px solid #000;
                            border-left: 1px solid #000;
                            line-height: 20px;
                            font-size: 12px;
                        }
                        tbody td {
                            border: 1px solid #000;
                        }
                        tbody {
                            text-align: center;
                            line-height: 20px;
                        }
                        table {
                            border-collapse: collapse;
                        }
                        `,
                    onLoadingStart: () => {
                        document.getElementById("span_t1").style.display = 'none';// 隐藏
                        document.getElementById("span_t2").style.display = '';// 显示
                        document.getElementById("table_t1").style.display = 'none';// 显示
                        document.getElementById("table_t2").style.display = '';// 隐藏
                        document.getElementById("table_t11").style.display = 'none';// 显示
                        document.getElementById("table_t22").style.display = '';// 隐藏
                        document.getElementById("printJS-form2").style.display = '';// 显示
                        console.log('打印开始');
                    },
                    onLoadingEnd: () => {
                        document.getElementById("printJS-form2").style.display = 'none';// 隐藏
                        console.log('打印完成');
                    }
                    //style: 'table tr td,th { border-collapse: collapse;padding: 15px;border:1px #000 solid; }' // 表格样式
                });
            },
            // 计算汇总求和
            getSummaries2(param) {
                // param 是固定的对象，里面包含 columns与 data参数的对象 {columns: Array[4], data: Array[5]},包含了表格的所有的列与数据信息
                const { columns, data } = param;
                // console.log(param);
                // console.log(data)
                const sums = [];
                columns.forEach((column, index) => {
                    // console.log(column)
                    // console.log(index)
                    if (index === 0) {
                        sums[index] = 'Total';
                        return;
                    }
                    if (index === 5) {
                        const values = data.map(item => Number(item[column.property]));
                        // 验证每个value值是否是数字，如果是执行if
                        if (!values.every(value => isNaN(value))) {
                            sums[index] = values.reduce((prev, curr) => {
                            // const value = Number(curr);
                            // if (!isNaN(value)) {
                            return prev + curr;
                            // } else {
                            //   return prev;
                            // }
                            }, 0);
                            sums[index] = sums[index].toFixed(2);
                        } else {
                            sums[index] = 'N/A';
                        }
                    }
                    if (index === 10) {
                        const values = data.map(item => Number(item[column.property]));
                        // 验证每个value值是否是数字，如果是执行if
                        if (!values.every(value => isNaN(value))) {
                            sums[index] = values.reduce((prev, curr) => {
                            // const value = Number(curr);
                            // if (!isNaN(value)) {
                            return prev + curr;
                            // } else {
                            //   return prev;
                            // }
                            }, 0);
                            sums[index] = Math.round(sums[index]);
                            // sums[index] += '';
                        } else {
                            sums[index] = 'N/A';
                        }
                    }
                });
                return sums;
            },
            // 批量作废数据
            savaDataParams2() {
                let _this = this;
                _this.idStr = _this.idList.join(',');
                util.publicget('/order/savaOrdersInfoStatus', {
                    // user: document.cookie.split(';')[1].split('=')[1],
                    user: sessionStorage.getItem('userName'),
                    action: '作废',
                    id: _this.idStr
                }, function (res) {
                    if (res.flag) {
                        // console.log(res);
                        _this.successMsg(res.msg);
                        _this.dialogTableVisible2 = false;
                        _this.selectList();
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
            },
            // 修改数据状态 收款
            savaDataParams3() {
                let _this = this;
                _this.idStr = _this.idList.join(',');
                var dataCopyStr = '';
                var forlist = this.dataOnLineListSelections;
                for (var i = 0; i < forlist.length; i++){
                    /*
                    if((forlist[i].received===null || forlist[i].received==='') && 
                        (forlist[i].received_usd===null || forlist[i].received_usd==='')){
                        _this.errorMsg('实收金额不能为空！');
                        return;
                    }
                    */
                    if(forlist[i].received_r===null || forlist[i].received_r===''){
                        _this.errorMsg('实收金额不能为空！');
                        return;
                    }
                    /*
                    if(forlist[i].price===null || forlist[i].price===''
                        || forlist[i].back===null || forlist[i].back===''
                        || forlist[i].rate===null || forlist[i].rate===''){
                            if((forlist[i].received===null || forlist[i].received==='') && 
                                (forlist[i].received_usd===null || forlist[i].received_usd==='')){
                                _this.errorMsg('订单退点、订单汇率、售价、实收金额均不能为空！');
                            }
                        return;
                    }*/

                    var dataCopy = forlist[i].id+','+forlist[i].cert_no
                                +','+forlist[i].back+','+forlist[i].rate
                                +','+forlist[i].price
                                +','+forlist[i].orders_usd
                                +','+forlist[i].received_r
                                +','+forlist[i].received_usd_r
                                +','+forlist[i].status+','+forlist[i].orders_no
                                +','+forlist[i].channel
                                +','+forlist[i].beilv
                                +';'
                    dataCopyStr = dataCopyStr + dataCopy
                }
                //this.$refs.addDataForm3.validate((valid) => {
                //    if (valid) { // 通过了则将数据返回后台
                util.publicget('/order/savaOrdersInfoStatus', {
                    // user: document.cookie.split(';')[1].split('=')[1],
                    user: sessionStorage.getItem('userName'),
                    action: '收款',
                    status: _this.addDataForm3.status,
                    received_type: _this.addDataForm3.received_type,
                    received: _this.addDataForm3.received,
                    remark1: _this.addDataForm3.remark1,
                    dataCopyStr: dataCopyStr,
                    id: _this.idStr
                }, function (res) {
                    if (res.flag) {
                        // console.log(res);
                        _this.successMsg(res.msg);
                        _this.dialogTableVisible3 = false;
                        _this.selectList();
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
                    //}
                //});
            },
            // 借出/归还 
            savaDataParams4() {
                let _this = this;
                _this.idStr = _this.idList.join(',');
                _this.cert_no = _this.certnoList.join(',').replaceAll('\n','');
                // 归还不需要保单校验
                if (_this.addDataForm4.islend === '2' || _this.addDataForm4.islend === '3') {
                    _this.rules4.vip[0].required = false;
                    // _this.rules4.dateline[0].required = false;
                } else {
                    _this.rules4.vip[0].required = true;
                    // _this.rules4.dateline[0].required = true;
                }
                this.$refs.addDataForm4.validate((valid) => {
                    if (valid) { // 通过了则将数据返回后台
                        util.publicget('/diamond/lendOrderInfo', {
                            // user: document.cookie.split(';')[1].split('=')[1],
                            user: sessionStorage.getItem('userName'),
                            islend: _this.addDataForm4.islend,
                            sale_rate: _this.ratevalue,
                            // sale_back: _this.addDataForm4.sale_back,
                            vip: _this.addDataForm4.vip,
                            dateline: _this.addDataForm4.dateline,
                            remark: _this.addDataForm4.remark,
                            id: _this.idStr,
                            cert_no: _this.cert_no
                        }, function (res) {
                            if (res.flag) {
                                // console.log(res);
                                _this.successMsg(res.msg);
                                _this.dialogTableVisible4 = false;
                                _this.selectList();
                            } else {
                                _this.errorMsg(res.msg);
                            }
                        })
                    }
                });
            },
            // 全款借货
            savaDataParams6() {
                let _this = this;
                _this.idStr = _this.idList.join(',');
                _this.cert_no = _this.certnoList.join(',').replaceAll('\n','');
                // 释放不需要保单校验
                if (_this.addDataForm3.islend === '2' || _this.addDataForm3.islend === '3'){
                    _this.rules3.clients[0].required = false;
                } else{
                    _this.rules3.clients[0].required = true;
                }
                this.$refs.addDataForm3.validate((valid) => {
                    if (valid) { // 通过了则将数据返回后台
                        util.publicget('/diamond/fullLendOrderInfo', {
                            // user: document.cookie.split(';')[1].split('=')[1],
                            user: sessionStorage.getItem('userName'),
                            sale_rate: _this.ratevalue,
                            // sale_back: _this.addDataForm3.sale_back,
                            clients: _this.addDataForm3.clients,
                            islend: _this.addDataForm3.islend,
                            remark2: _this.addDataForm3.remark2,
                            cert_no: _this.cert_no,
                            id: _this.idStr
                        }, function (res) {
                            if (res.flag) {
                                // console.log(res);
                                _this.successMsg(res.msg);
                                _this.dialogTableVisible9 = false;
                                _this.selectList();
                            } else {
                                _this.errorMsg(res.msg);
                            }
                        })
                    }
                });
            },
            // 带证书号复制
            selectCertnoCopy() {
                var dataCopyStr = ''
                var forlist = this.dataOnLineListSelections
                for(var i=0; i<forlist.length; i++){

                    let placeStr = '深圳';
                    if(forlist[i].place === 'HK' || forlist[i].place === 'hk' || forlist[i].place === 'H-K'){
                        placeStr = '香港';
                    }else if(forlist[i].place === 'CHINA' || forlist[i].place === 'china' || forlist[i].place === 'CN'){
                        placeStr = '中国';
                    }else if(forlist[i].place === 'sh' || forlist[i].place === 'SH'){
                        placeStr = '上海';
                    }
                    /*
                    // 折扣
                    let new_disStr = forlist[i].new_dis;
                    if(this.baojiaform.all_new_dis){
                        new_disStr = parseFloat(new_disStr) + parseFloat(this.baojiaform.all_new_dis)
                    }
                    // 汇率
                    let sale_rateStr = forlist[i].sale_rate;
                    if(this.baojiaform.all_sale_rate){
                        sale_rateStr = this.baojiaform.all_sale_rate;
                    }
                    
                    let sale_usd = (forlist[i].sale_rap*(1+(new_disStr/100)) *forlist[i].ct).toFixed(2)
                    let sale_price = Math.round((forlist[i].beilv * sale_rateStr * sale_usd).toFixed(2))
                    */
                    if(forlist[i].place === 'HK' || forlist[i].place === 'hk' || forlist[i].place === 'H-K'){
                        var dataCopy = forlist[i].shape+', '+forlist[i].ct+', '+forlist[i].col+', '+forlist[i].cla
                                +', '+forlist[i].cut+', '+forlist[i].pol+', '+forlist[i].sym+', '+forlist[i].fl
                                +', '+forlist[i].back+'%, $'+forlist[i].sale_usd_r
                                +', '+forlist[i].cert+', '+forlist[i].cert_no+', '+placeStr+'；'
                        if(dataCopyStr == ''){
                            dataCopyStr = dataCopy
                        }else{
                            dataCopyStr = dataCopyStr + '\n' + dataCopy
                        }
                    }else{
                        var dataCopy = forlist[i].shape+', '+forlist[i].ct+', '+forlist[i].col+', '+forlist[i].cla
                                +', '+forlist[i].cut+', '+forlist[i].pol+', '+forlist[i].sym+', '+forlist[i].fl
                                +', '+forlist[i].back+'%, ¥'+forlist[i].sale_price_r
                                +', '+forlist[i].cert+', '+forlist[i].cert_no+', '+placeStr+'；'
                        if(dataCopyStr == ''){
                            dataCopyStr = dataCopy
                        }else{
                            dataCopyStr = dataCopyStr + '\n' + dataCopy
                        }
                    }
                    
                }
                // console.log(dataCopyStr)
                // 数据拼接
                // var dataCopy = this.dataOnLineListSelections.map((item) => item.shape+','+item.ct+','+item.col+','+item.cla+','+item.cut+','+item.pol+','+item.sym+','+item.fl+','+item.new_dis+',¥'+item.sale_price+','+item.cert+','+item.cert_no+';\n')
                // console.log(dataCopy)
                // 复制
                this.copyText(dataCopyStr);
            },
            copyText(val){
                // 存储传递过来的数据
                //let userId = sessionStorage.getItem("userId");
                // createElement() 方法通过指定名称创建一个元素
                let newInput = document.createElement('textarea');
                // 讲存储的数据赋值给input的value值
                newInput.value = val;
                // appendChild() 方法向节点添加最后一个子节点
                document.body.appendChild(newInput);
                // select() 方法用于选择该元素中的文本
                newInput.select();
                // execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
                document.execCommand('Copy');
                // 清空输入框
                newInput.remove();
                // 下面是element的弹窗 不需要的自行删除就好
                this.$message({
                    message: "复制成功",
                    type: "success",
                });
            },
            // 钻石报价
            savaDataParams42() {
                let _this = this;
                _this.idStr = _this.idList.join(',');
                var dataCopyStr = '';
                var forlist = this.dataOnLineListSelections;
                for (var i = 0; i < forlist.length; i++){
                    /*
                    if((forlist[i].received===null || forlist[i].received==='') && 
                        (forlist[i].received_usd===null || forlist[i].received_usd==='')){
                        _this.errorMsg('实收金额不能为空！');
                        return;
                    }
                    */
                    var dataCopy = forlist[i].id
                                +','+forlist[i].cert_no
                                +','+forlist[i].back
                                +','+forlist[i].rate
                                +','+forlist[i].sale_price_r
                                +','+forlist[i].orders_usd
                                +','+forlist[i].status
                                +','+forlist[i].orders_no+';'
                    dataCopyStr = dataCopyStr + dataCopy
                }
                util.publicget('/order/adjustOrderPriceInfo', {
                    // user: document.cookie.split(';')[1].split('=')[1],
                    user: sessionStorage.getItem('userName'),
                    id: _this.idStr,
                    dataCopyStr: dataCopyStr
                }, function (res) {
                    if (res.flag) {
                        // console.log(res);
                        _this.successMsg(res.msg);
                        _this.dialogTableVisible7 = false;
                        _this.selectList();
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
            },
            // 批量调整折扣
            savaDataParams40() {
                let _this = this;
                _this.idStr = _this.idList.join(',');
                this.$refs.addDataForm5.validate((valid) => {
                    if (valid) { // 通过了则将数据返回后台
                        util.publicget('/order/adjustDisInfo', {
                            // user: document.cookie.split(';')[1].split('=')[1],
                            user: sessionStorage.getItem('userName'),
                            new_dis: _this.addDataForm5.new_dis,
                            id: _this.idStr
                        }, function (res) {
                            if (res.flag) {
                                // console.log(res);
                                _this.successMsg(res.msg);
                                _this.dialogTableVisible6 = false;
                                _this.selectList();
                            } else {
                                _this.errorMsg(res.msg);
                            }
                        })
                    }
                });
            },
            // 批量调整汇率
            savaDataParams41() {
                let _this = this;
                _this.idStr = _this.idList.join(',');
                this.$refs.addDataForm5.validate((valid) => {
                    if (valid) { // 通过了则将数据返回后台
                        util.publicget('/order/savaOrdersInfoStatus', {
                            // user: document.cookie.split(';')[1].split('=')[1],
                            user: sessionStorage.getItem('userName'),
                            action: '调整汇率',
                            rate: _this.addDataForm5.rate,
                            id: _this.idStr
                        }, function (res) {
                            if (res.flag) {
                                // console.log(res);
                                _this.successMsg(res.msg);
                                _this.dialogTableVisible5 = false;
                                _this.selectList();
                            } else {
                                _this.errorMsg(res.msg);
                            }
                        });
                    }
                });
            },
            // 确认退货
            rebackOrders(rows){
                let _this = this;
                util.publicget('/order/rebackOrders', {
                    // user: document.cookie.split(';')[1].split('=')[1],
                    user: sessionStorage.getItem('userName'),
                    equalsId: rows.id,
                    equalsCert_no: rows.cert_no
                }, function (res) {
                    if (res.flag) {
                        _this.successMsg(res.msg);
                        _this.selectList();
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
            },
            // 已完成货品，或者其他收钱的需要退货
            rebackEndOrders(){
                let _this = this;
                let idStr = _this.idList.join(',');
                let cert_noStr = _this.certnoList.join(',').replaceAll('\n','');
                util.publicget('/order/rebackEndOrders', {
                    // user: document.cookie.split(';')[1].split('=')[1],
                    user: sessionStorage.getItem('userName'),
                    idStr: idStr,
                    cert_noStr: cert_noStr
                }, function (res) {
                    if (res.flag) {
                        _this.successMsg(res.msg);
                        _this.dialogTableVisible11 = false;
                        _this.selectList();
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
            },
            // 结清 财务来进行操作，结清后更新进销存数据
            closeOutOrders(rows){
                let _this = this;
                util.publicget('/order/closeOutOrders', {
                    // user: document.cookie.split(';')[1].split('=')[1],
                    user: sessionStorage.getItem('userName'),
                    idStr: rows.id,
                    equalsCert_no: rows.cert_no
                }, function (res) {
                    if (res.flag) {
                        _this.successMsg(res.msg);
                        _this.selectList();
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
            },
            // 批量结清
            closeOutAllOrders(){
                let _this = this;
                _this.idStr = _this.idList.join(',');
                util.publicget('/order/closeOutOrders', {
                    // user: document.cookie.split(';')[1].split('=')[1],
                    user: sessionStorage.getItem('userName'),
                    idStr: _this.idStr
                }, function (res) {
                    if (res.flag) {
                        _this.successMsg(res.msg);
                        _this.selectList();
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
            },
            // 删除数据
            savaDataParams5() {
                let _this = this;
                _this.idStr = _this.idList.join(',');
                util.publicget('/order/deleteOrdersInfo', {
                    // user: document.cookie.split(';')[1].split('=')[1],
                    user: sessionStorage.getItem('userName'),
                    id: _this.idStr
                }, function (res) {
                    if (res.flag) {
                        // console.log(res);
                        _this.successMsg(res.msg);
                        _this.dialogTableVisible8 = false;
                        _this.selectList();
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
            },
            // 修改订单数据
            savaDataParams() {
                let _this = this;
                // 判断表单是否通过了表单验证
                this.$refs.addDataForm.validate((valid) => {
                    if (valid) { // 通过了则将数据返回后台
                        util.publicget('/order/savaOrdersInfo', {
                            // user: document.cookie.split(';')[1].split('=')[1],
                            user: sessionStorage.getItem('userName'),
                            stock_id: _this.addDataForm.stock_id,
                            cert_no: _this.addDataForm.cert_no,
                            other_no: _this.addDataForm.other_no,
                            id: _this.addDataForm.id,
                            
                            orders_usd: _this.addDataForm.orders_usd,
                            rate: _this.addDataForm.rate,
                            back: _this.addDataForm.back,
                            status: _this.addDataForm.status,
                            place: _this.addDataForm.place,
                            create_user: _this.addDataForm.create_user,
                            received_type: _this.addDataForm.received_type,
                            price: _this.addDataForm.price,
                            received: _this.addDataForm.received,
                            received_usd: _this.addDataForm.received_usd,
                            deal_date: _this.addDataForm.deal_date,
                            clients: _this.addDataForm.clients,
                            remark: _this.addDataForm.remark
                        }, function (res) {
                            if (res.flag) {
                                _this.dialogTableVisible10 = false;
                                _this.successMsg('本次操作成功！');
                                _this.selectList();
                            } else {
                                _this.errorMsg(res.msg);
                            }
                        });
                    } else { // 否则返回
                        return false;
                    }
                });
            },
            // 查询数据字典 地点
            selectPlaceDictList() {
                let _this = this;
                util.publicget('/diamond/queryDaimondDictList', {
                    equalsParam: '地点'
                }, function (res) {
                    if (res.flag) {
                        // console.log(res.obj);
                        _this.placeList = res.obj;
                    } else {
                        _this.errorMsg("操作异常！");
                    }
                });
            },
            // dialog 关闭，数据清空
            closeSava() {
                this.addDataForm = {};
                this.addDataForm5 = {};
                this.dialogTableVisible10 = false;
                this.isShow = false;
                //this.isAble = true;
                this.isdisabled = false;
                this.rules4.vip[0].required = true;
                this.baojiaform = {};
                this.shoukuanform = {};
                // this.dataOnLineListSelections = {};
                // this.rules4.dateline[0].required = true;
                this.selectList();
            },
            // 前端处理 导出选中数据
            exportSelect() {
                //let res =[{name:'小白',age:'18'},{name:'小黑',age:'16'}]
                require.ensure([], () => {
                    const { export_json_to_excel } = require('../common/js/Export2Excel.js')
                    const tHeader = ['订单号','证书号','订单状态','地点', '形状', '重量'
                            , '颜色', '净度', '切工', '抛光', '对称', '荧光', '证书'
                            , '销售rap','USD','RMB', '订单退点', '汇率', '客户姓名'
                            , '实收RMB', '实收USD', '业务员', '下单日期'
                            , '取货日期', '付款日期','数据日期'];
                    const filterVal = ['orders_no', 'cert_no','status','place', 'shape', 'ct'
                            ,'col', 'cla', 'cut', 'pol', 'sym', 'fl', 'cert'
                            ,'sale_rap', 'orders_usd', 'price', 'back', 'rate', 'clients'
                            ,'received', 'received_usd', 'update_user', 'order_date'
                            ,'pick_date', 'pay_date', 'data_date'];
                    const list = this.dataOnLineListSelections
                    const data = this.formatJson(filterVal, list)
                    export_json_to_excel(tHeader, data, '订单信息')
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
            // 导出全部数据
            exportAll() {
                //let res =[{name:'小白',age:'18'},{name:'小黑',age:'16'}]
                require.ensure([], () => {
                    const { export_json_to_excel } = require('../common/js/Export2Excel.js');
                    const tHeader = ['订单号','证书号','订单状态','地点', '形状', '重量'
                            , '颜色', '净度', '切工', '抛光', '对称', '荧光', '证书'
                            , '销售rap','USD','RMB', '订单退点', '汇率', '客户姓名'
                            , '实收RMB', '实收USD', '业务员', '下单日期'
                            , '取货日期', '付款日期','数据日期'];
                    const filterVal = ['orders_no', 'cert_no','status','place', 'shape', 'ct'
                            ,'col', 'cla', 'cut', 'pol', 'sym', 'fl', 'cert'
                            ,'sale_rap', 'orders_usd', 'price', 'back', 'rate', 'clients'
                            ,'received', 'received_usd', 'update_user', 'order_date'
                            ,'pick_date', 'pay_date', 'data_date'];
                    const list = this.orderAllInfoList;
                    const data = this.formatJson(filterVal, list);
                    export_json_to_excel(tHeader, data, '全部订单信息');
                });
            },
            // 查询全部数据用于导出
            selectAllOrderList() {
                let _this = this;
                util.publicget('/order/queryOrdersList', {
                }, function (res) {
                    if (res.flag) {
                        // console.log(res.obj);
                        if ( res.obj.length > 0) {
                            _this.orderAllInfoList = res.obj;
                            _this.exportAll();
                        } else {
                            _this.errorMsg('导出失败！');
                        }
                    } else {
                        _this.errorMsg("导出失败！");
                    }
                });
            },
            // 展开行查询数据处理
            expandChange(row, expandedRows) {
                this.aimDiffBasicList.forEach(item => {
                    this.$set(item, 'ruleItemData', [{'project': '444'}]);
                });
            },
            // 加载订单信息分页列表
            selectList() {
                let _this = this;
                // const statusStr = '保留-已取消,借货-已取消,全款借货-待退货,无效订单';
                util.publicget('/order/queryOrderInfoListPageModel', {
                    user: sessionStorage.getItem('userName'),
                    shape: _this.query.shape,
                    col: _this.query.col,
                    cla: _this.query.cla,
                    cut: _this.query.cut,
                    pol: _this.query.pol,
                    sym: _this.query.sym,
                    fl: _this.query.fl,
                    place: _this.query.place,
                    equalsReceived_type: _this.query.received_type,
                    cert: _this.query.cert,
                    status: _this.statusStr,
                    create_user: _this.query.create_user,
                    mine: _this.checked,
                    clients: _this.query.clients,
                    remark: _this.query.remark,
                    // status: _this.query.status === '无效订单' ? statusStr : _this.query.status,
                    cert_no: _this.query.danhao === '1' ? _this.query.goods_no : '',
                    equalsOrders_no: _this.query.danhao === '2' ? _this.query.goods_no : '',
                    equalsClients: _this.query.huiyuan === '1' ? _this.query.name : '',
                    company_name: _this.query.huiyuan === '2' ? _this.query.name : '',
                    greaterEqualsOrder_date: _this.query.order_date == null ? '' : _this.query.order_date[0],
                    lessEqualsOrder_date: _this.query.order_date == null ? '' : _this.query.order_date[1],
                    greaterEqualsPick_date: _this.query.pick_date == null ? '' : _this.query.pick_date[0],
                    lessEqualsPick_date: _this.query.pick_date == null ? '' : _this.query.pick_date[1],
                    greaterEqualsPay_date: _this.query.pay_date == null ? '' : _this.query.pay_date[0],
                    lessEqualsPay_date: _this.query.pay_date == null ? '' : _this.query.pay_date[1],
                    equalsSupplier: _this.query.supplier,
                    greaterEqualsCt: _this.query.ct1,
                    lessEqualsCt: _this.query.ct2,
                    pageNo: _this.pager.page,
                    pageSize: _this.pager.rows
                }, function (res) {
                    if (res.flag) {
                        // console.log(res);
                        _this.pager.total = res.count || 0;
                        if(res.count < _this.pager.rows){
                            _this.pager.page = 1;
                        }
                        _this.orderInfoList = res.obj;
                        _this.certnoList = res.obj.map((item) => item.cert_no + '\n');
                        _this.idList = res.obj.map((item) => item.id);
                    } else {
                        _this.errorMsg('本次操作失败');
                    }
                });
            },
            // 加载查询订单单条记录
            selectOrderList(rows) {
                let _this = this;
                util.publicget('/order/queryOrdersList', {
                    equalsId: rows.id,
                    equalsCert_no: rows.cert_no
                }, function (res) {
                    if (res.flag) {
                        //console.log(res.obj);
                        if ( res.obj.length > 0) {
                            _this.addDataForm = res.obj[0];
                            _this.dialogTableVisible10 = true;
                        } else {
                            _this.showMsg('该证书号数据不存在');
                        }
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
            },
            // 计算汇总求和
            getSummaries_sk(param) {
                // param 是固定的对象，里面包含 columns与 data参数的对象 {columns: Array[4], data: Array[5]},包含了表格的所有的列与数据信息
                const { columns, data } = param;
                // console.log(param);
                // console.log(data)
                const sums = [];
                columns.forEach((column, index) => {
                    // console.log(column)
                    // console.log(index)
                    if (index === 0) {
                        sums[index] = '合计';
                        return;
                    }
                    if (index === 1) {
                        const values = data.map(item => Number(item[column.property]));
                        // 验证每个value值是否是数字，如果是执行if
                        if (!values.every(value => isNaN(value))) {
                            sums[index] = values.reduce((prev, curr) => {
                            // const value = Number(curr);
                            // if (!isNaN(value)) {
                            return prev + curr;
                            // } else {
                            //   return prev;
                            // }
                            }, 0);
                            sums[index] = sums[index].toFixed(2);
                        } else {
                            sums[index] = 'N/A';
                        }
                    }
                    if (index === 13) {
                        const values = data.map(item => Number(item[column.property]));
                        // 验证每个value值是否是数字，如果是执行if
                        if (!values.every(value => isNaN(value))) {
                            sums[index] = values.reduce((prev, curr) => {
                            // const value = Number(curr);
                            // if (!isNaN(value)) {
                            return prev + curr;
                            // } else {
                            //   return prev;
                            // }
                            }, 0);
                            sums[index] = Math.round(sums[index]);
                        } else {
                            sums[index] = 'N/A';
                        }
                    }
                    if (index === 14) {
                        const values = data.map(item => Number(item[column.property]));
                        // 验证每个value值是否是数字，如果是执行if
                        if (!values.every(value => isNaN(value))) {
                            sums[index] = values.reduce((prev, curr) => {
                            // const value = Number(curr);
                            // if (!isNaN(value)) {
                            return prev + curr;
                            // } else {
                            //   return prev;
                            // }
                            }, 0);
                            sums[index] = Math.round(sums[index]);
                        } else {
                            sums[index] = 'N/A';
                        }
                    }
                    if (index === 16) {
                        const values = data.map(item => Number(item[column.property]));
                        // 验证每个value值是否是数字，如果是执行if
                        if (!values.every(value => isNaN(value))) {
                            sums[index] = values.reduce((prev, curr) => {
                            // const value = Number(curr);
                            // if (!isNaN(value)) {
                            return prev + curr;
                            // } else {
                            //   return prev;
                            // }
                            }, 0);
                            sums[index] = Math.round(sums[index]);
                        } else {
                            sums[index] = 'N/A';
                        }
                    }
                    if (index === 17) {
                        const values = data.map(item => Number(item[column.property]));
                        // 验证每个value值是否是数字，如果是执行if
                        if (!values.every(value => isNaN(value))) {
                            sums[index] = values.reduce((prev, curr) => {
                            // const value = Number(curr);
                            // if (!isNaN(value)) {
                            return prev + curr;
                            // } else {
                            //   return prev;
                            // }
                            }, 0);
                            sums[index] = Math.round(sums[index]);
                        } else {
                            sums[index] = 'N/A';
                        }
                    }
                    /*
                    if (index === 15) {
                        const values = data.map(item => Number(item[column.property]));
                        // 验证每个value值是否是数字，如果是执行if
                        if (!values.every(value => isNaN(value))) {
                            sums[index] = values.reduce((prev, curr) => {
                            // const value = Number(curr);
                            // if (!isNaN(value)) {
                            return prev + curr;
                            // } else {
                            //   return prev;
                            // }
                            }, 0);
                            sums[index] = Math.round(sums[index]);
                        } else {
                            sums[index] = 'N/A';
                        }
                    }
                    */
                });
                return sums;
            },
            // 取消
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.checkboxGroup1 = [];
                this.checkboxGroup2 = [];
                this.checkboxGroup3 = [];
                this.checkboxGroup4 = [];
                this.checkboxGroup5 = [];
                this.checkboxGroup6 = [];
                this.checkboxGroup7 = [];
                this.checkboxGroup8 = [];
                this.checkboxGroup9 = [];
                this.statusOptions = [];
                this.statusStr = '';
                this.query = {};
                this.$set(this.query, 'danhao', '1');
                this.$set(this.query, 'huiyuan', '1');
            },
            // 计算汇总求和
            getSummaries4(param) {
                // param 是固定的对象，里面包含 columns与 data参数的对象 {columns: Array[4], data: Array[5]},包含了表格的所有的列与数据信息
                const { columns, data } = param;
                // console.log(param);
                // console.log(data)
                const sums = [];
                columns.forEach((column, index) => {
                    // console.log(column)
                    // console.log(index)
                    if (index === 0) {
                        sums[index] = '合计';
                        return;
                    }
                    if (index === 1) {
                        const values = data.map(item => Number(item[column.property]));
                        // 验证每个value值是否是数字，如果是执行if
                        if (!values.every(value => isNaN(value))) {
                            sums[index] = values.reduce((prev, curr) => {
                            // const value = Number(curr);
                            // if (!isNaN(value)) {
                            return prev + curr;
                            // } else {
                            //   return prev;
                            // }
                            }, 0);
                            sums[index] = sums[index].toFixed(2);
                        } else {
                            sums[index] = 'N/A';
                        }
                    }
                    if (index === 13) {
                        const values = data.map(item => Number(item[column.property]));
                        // 验证每个value值是否是数字，如果是执行if
                        if (!values.every(value => isNaN(value))) {
                            sums[index] = values.reduce((prev, curr) => {
                            // const value = Number(curr);
                            // if (!isNaN(value)) {
                            return prev + curr;
                            // } else {
                            //   return prev;
                            // }
                            }, 0);
                            sums[index] = Math.round(sums[index]);
                        } else {
                            sums[index] = 'N/A';
                        }
                    }
                    if (index === 14) {
                        const values = data.map(item => Number(item[column.property]));
                        // 验证每个value值是否是数字，如果是执行if
                        if (!values.every(value => isNaN(value))) {
                            sums[index] = values.reduce((prev, curr) => {
                            // const value = Number(curr);
                            // if (!isNaN(value)) {
                            return prev + curr;
                            // } else {
                            //   return prev;
                            // }
                            }, 0);
                            sums[index] = Math.round(sums[index]);
                        } else {
                            sums[index] = 'N/A';
                        }
                    }
                });
                return sums;
            },
            // 时间格式化
            formatterDate(row, column) {
                return util.formatDate.format(new Date(row.order_date), 'yyyy-MM-dd');
            },
            getNowTime() {
                var now = new Date();
                var year = now.getFullYear();
                var month = now.getMonth();
                var date = now.getDate();
                month = month + 1;
                month = month.toString().padStart(2, '0');
                date = date.toString().padStart(2, '0');
                var defaultDate = `${year}-${month}-${date}`;
                return defaultDate;
            },
        },
        mounted() {
            this.selectList();
            this.selectPlaceDictList();
        }
    };
</script>

<style lang="scss">
    /**奇偶行变色 */
    .el-table__row--striped td {
        background-color: #eaf3fb !important;
    }
    /** 修改表格行高 */
    .el-table .el-table__cell{
        padding: 3px 0px
    }
    /**横线 */
    .line_div {
        float:right;
        width: 100%;
        height: 1px;
        margin-top: -0.5em;
        background: black;
        position: relative;
        text-align: center;
    }
    /**横虚线 */
    .tableLine {
        position: relative;
        margin: 0 auto;
        width: 600px;
        height: 1px;
        background-color: black;
        text-align: center;
        font-size: 12px;
    }
    .midText {
        position: absolute;
        left: 50%;
        background-color: black;
        padding: 0 15px;
        transform: translateX(-50%) translateY(-50%);
    }
    .el-icon-round {
        background:url('../assets/images/cut/round.png') center no-repeat;
        background-size: 40px 40px;
        width: 40px;
        height: 40px;
        margin: -9px;
        border-radius: 1px;
    }
    .el-icon-princess {
        background:url('../assets/images/cut/princess.png') center no-repeat;
        background-size: 40px 40px;
        width: 40px;
        height: 40px;
        margin: -9px;
        border-radius: 1px;
    }
    .el-icon-radiant {
        background:url('../assets/images/cut/radiant.png') center no-repeat;
        background-size: 40px 40px;
        width: 40px;
        height: 40px;
        margin: -9px;
        border-radius: 1px;
    }
    .el-icon-asscher {
        background:url('../assets/images/cut/asscher.png') center no-repeat;
        background-size: 40px 40px;
        width: 40px;
        height: 40px;
        margin: -9px;
        border-radius: 1px;
    }
    .el-icon-marquise {
        background:url('../assets/images/cut/marquise.png') center no-repeat;
        background-size: 40px 40px;
        width: 40px;
        height: 40px;
        margin: -9px;
        border-radius: 1px;
    }
    .el-icon-oval {
        background:url('../assets/images/cut/oval.png') center no-repeat;
        background-size: 40px 40px;
        width: 40px;
        height: 40px;
        margin: -9px;
        border-radius: 1px;
    }
    .el-icon-emerald {
        background:url('../assets/images/cut/emerald.png') center no-repeat;
        background-size: 40px 40px;
        width: 40px;
        height: 40px;
        margin: -9px;
        border-radius: 1px;
    }
    .el-icon-pear {
        background:url('../assets/images/cut/pear.png') center no-repeat;
        background-size: 40px 40px;
        width: 40px;
        height: 40px;
        margin: -9px;
        border-radius: 1px;
    }
    .el-icon-heart {
        background:url('../assets/images/cut/heart.png') center no-repeat;
        background-size: 40px 40px;
        width: 40px;
        height: 40px;
        margin: -9px;
        border-radius: 1px;
    }
    .el-icon-cushion {
        background:url('../assets/images/cut/cushion.png') center no-repeat;
        background-size: 40px 40px;
        width: 40px;
        height: 40px;
        margin: -9px;
        border-radius: 1px;
    }
    .el-icon-others {
        background:url('../assets/images/cut/others.png') center no-repeat;
        background-size: 40px 40px;
        width: 40px;
        height: 40px;
        margin: -9px;
        border-radius: 1px;
    }
    .el-icon-triangle {
        background:url('../assets/images/cut/triangle.png') center no-repeat;
        background-size: 40px 40px;
        width: 40px;
        height: 40px;
        margin: -9px;
        border-radius: 1px;
    }
    .el-dialog{
        display: flex;
        flex-direction: column;
        margin: 0 !important;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    /*
    ::v-deep .el-table__expand-icon {
        display: none !important;
    }*/
    .el-dialog .el-dialog__body{
        flex: 1;
        overflow: auto;
    }
     /*:header-cell-style="{background:'#eee8aa'}"
    .el-table--border:after,
    .el-table--group:after,
    .el-table:before{
        background-color: #eee8aa
    }

    .el-table--border,
    .el-table--group{
        border-color: #eee8aa
    }

    .el-table td,
    .el-table th.is-leaf{
        border-bottom: #eee8aa
    }

    .el-table--border th,
    .el-table--border th.gutter:last-of-type{
        border-bottom: #eee8aa
    }

    .el-table--border td,
    .el-table--border th{
        border-right: #eee8aa
    }
    */
</style>



// WEBPACK FOOTER //
// src/pages/ordersInfoList.vue